import React, { useEffect, useState, useRef, useMemo, useId } from "react";
import {
  Search,
  Clock,
  Beaker,
  Pill,
  MoreHorizontal,
  User,
  ShoppingCart,
  ArrowLeft,
  Users,
  Calendar,
  ClipboardList,
  CheckCircle2,
  ChevronRight,
  Shield,
  Lock,
  SlidersHorizontal,
  Phone,
  MapPin,
  Globe,
  HelpCircle,
  Ambulance as AmbulanceIcon,
  Check,
} from "lucide-react";
import OurLayouts from "../layout";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { enIN } from "date-fns/locale";
import PaymentModeModal from "../PatientRegister/PaymentModeModal";
import book from "../../assets/booksrevice.png";
import { AutoComplete } from "primereact/autocomplete";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import searchicon from "../../assets/search_icon.svg";
import Labimg from "../../assets/labtest_icon.svg";
import medicineimg from "../../assets/medicineicon.svg";
import bookMedicineIcon from "../../assets/bookmedicineicon.svg";
import bookLabIcon from "../../assets/booklabicon.svg";
import surgeryIcon from "../../assets/surgeryinewcon.svg";
import nocurrentpatient from "../../assets/nocurrentpatient.svg";
import FullScreenLoader from "../FullScreenLoader";
import { Edit2, Trash2 } from "lucide-react";
import { ProgressSpinner } from "primereact/progressspinner";
import CartDropdown from "../../components/CartDropdown";
import Surgery from "./Surgery";
import Ambulance from "./Ambulance";
import AddMedicineModal from "./AddMedicineModal";
import AddLabTestModal from "./AddLabTestModal";
import { getMedicineDisplayPrice } from "./medicinePrice";
import { getLabItemKey } from "./labTestUtils";

const SEARCH_HINT_PREFIX = "Search by";
const SEARCH_HINT_WORDS = ["patient name", "mobile number"];
const SEARCH_HINT_INTERVAL_MS = 2000;

function AnimatedSearchHint({ active }) {
  const [wordIndex, setWordIndex] = useState(0);

  useEffect(() => {
    if (!active) return undefined;

    const intervalId = window.setInterval(() => {
      setWordIndex((prev) => (prev + 1) % SEARCH_HINT_WORDS.length);
    }, SEARCH_HINT_INTERVAL_MS);

    return () => window.clearInterval(intervalId);
  }, [active]);

  return (
    <span className="inline-flex items-center max-w-full overflow-hidden text-gray-400">
      <span className="shrink-0">{`${SEARCH_HINT_PREFIX}\u00A0`}</span>
      <span className="search-hint-carousel" aria-hidden>
        <span
          className="search-hint-carousel-track"
          style={{
            transform: `translate3d(0, -${wordIndex * (100 / SEARCH_HINT_WORDS.length)}%, 0)`,
          }}
        >
          {SEARCH_HINT_WORDS.map((word) => (
            <span key={word} className="search-hint-carousel-word">
              {word}
            </span>
          ))}
        </span>
      </span>
    </span>
  );
}

function CartAddIcon({ gradientId }) {
  const grad = `url(#${gradientId})`;
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      aria-hidden="true"
      className="flex-shrink-0"
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="3"
          y1="13"
          x2="23"
          y2="13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#004172" />
          <stop offset="1" stopColor="#3cba84" />
        </linearGradient>
      </defs>
      <path
        d="M5.5 5.5h13.5L17.5 15H8L5.5 5.5zM5.5 5.5L4 2.5H2"
        stroke={grad}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="9" cy="18.5" r="1.25" fill={grad} />
      <circle cx="16.5" cy="18.5" r="1.25" fill={grad} />
      <circle cx="19.5" cy="6.5" r="4" fill={grad} />
      <path
        d="M19.5 4.5v4M17.5 6.5h4"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const cartAddGradientId = useId().replace(/:/g, "");
  const patientCodeFromNav = location.state?.patientCode;
  const patientNameFromNav = location.state?.patientName;
  const whenAppointmentFromNav = location.state?.whenAppointment;
  const API_URL = process.env.REACT_APP_API_URL;
  const [selectedMedicines, setSelectedMedicines] = useState([]);
  const [selectedLabs, setSelectedLabs] = useState([]);
  const [patientList, setPatientList] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [abdmData, setAbdmData] = useState(null);
  const [medicinesData, setMedicinesData] = useState([]);
  const [labTestsData, setLabTestsData] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showAddModal3, setShowAddModal3] = useState(false);
  const [surgerymodal, setSurgeryModal] = useState(false);
  const [ambulanceModal, setAmbulanceModal] = useState(false);
  const [newMedicine, setNewMedicine] = useState({
    name: "",
    composition: "",
    medicineTypeOfSell: "",
    medicineRate: "",
    drugCategory: "",
    route: "",
    drugCode: "",
    prescriptionRequired: "",
    quantity: 1,
    dosage: "1-0-1",
  });
  const [newMedicine2, setNewMedicine2] = useState({
    name: "",
    composition: "",
    medicineTypeOfSell: "",
    medicineRate: "",
    drugCategory: "",
    route: "",
    drugCode: "",
    prescriptionRequired: "",
    quantity: 1,
    dosage: "1-0-1",
  });
  const [totalAmount, setTotalAmount] = useState(0);
  const [medicineBill, setMedicineBill] = useState(0);
  const [labTestBill, setLabTestBill] = useState(0);
  console.log(patientCodeFromNav, "patientCodeFromNav");
  const [showAddLabModal, setShowAddLabModal] = useState(false);
  const [manualLabTest, setManualLabTest] = useState("");
  const [customLabTests, setCustomLabTests] = useState([]);
  const [uploadedPrescription, setUploadedPrescription] = useState(null);
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [previewImageURL, setPreviewImageURL] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [paymentMode, setPaymentMode] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [orderid, setorderid] = useState("");
  const [removingItems, setRemovingItems] = useState(new Set());
  const [cartId, setCartId] = useState(null);
  const [cartEntryIds, setCartEntryIds] = useState({});
  const [loading, setLoading] = useState(false);
  const [removeMedicineLoading, setRemoveMedicineLoading] = useState(false);
  const [addMedicineLoading, setAddMedicineLoading] = useState(false);
  const [currentAppointmentDetails, setCurrentAppointmentDetails] = useState({
    appointmentId: null,
    whenAppointment: null,
  });
  const [testOptions, setTestOptions] = useState([]);
  const [selectedLabDetails, setSelectedLabDetails] = useState([]);
  const [selectedLab, setSelectedLab] = useState();
  const [tempSelectedLabs, setTempSelectedLabs] = useState([]);
  const [removingLabs, setRemovingLabs] = useState(new Set());
  const [cartList, setCartList] = useState([]);
  const [labCartDetails, setLabCartDetails] = useState(null);
  const [medicines, setMedicines] = useState([]);
  const [showAddLabModal2, setShowAddLabModal2] = useState(false);
  const [manualLabTest2, setManualLabTest2] = useState("");
  const typingTimeoutRef = useRef(null);
  const [landingSearchFocused, setLandingSearchFocused] = useState(false);
  // Calculate total cart items
  const cartItemCount = selectedMedicines.length + selectedLabs.length;
  const [loadingOcr, setLoadingOcr] = useState(false);
  const [testOptions2, setTestOptions2] = useState([]);
  const [loadingMedicines, setLoadingMedicines] = useState(new Set());
  const [loadingMedicines2, setLoadingMedicines2] = useState(new Set());
  const [loadingLabIds, setLoadingLabIds] = useState({});
  const [selectedLabTests, setSelectedLabTests] = useState([]);
  const [labCartEntryIds, setLabCartEntryIds] = useState({});
  const [CartOpen, setCartOpen] = useState(false);
  const { patient } = location.state || {};
  console.log(patient, "dfghjhbjnkhj");
  const [patientDetails, setPatientDetails] = useState({});

  // Initialize selectedPatient with patient data from location.state if available.
  // Normalise: some callers (e.g. Symptom Checker) pass patientCode instead of patientId.
  useEffect(() => {
    if (patient && (patient.patientId || patient.patientCode)) {
      setSelectedPatient({
        ...patient,
        patientId: patient.patientId || patient.patientCode,
        patientName: patient.patientName ||
          [patient.firstName, patient.lastName].filter(Boolean).join(' '),
      });
    }
    console.log(patient, "dcfgvhbjngvhbj");
  }, [patient]);

  useEffect(() => {
    if (location.state?.openAmbulance) {
      setAmbulanceModal(true);
    }
  }, [location.state?.openAmbulance]);
  console.log(selectedPatient, "selectedPatient");
  useEffect(() => {
    setLoading(true);
    const fetchLab = async () => {
      const response = await axios
        .get(
          `${process.env.REACT_APP_API_URL_DOCTOR}DiagnosticsLabTests/list/filter?parentId=0&status=1`,
        )
        .then((response) => {
          const options = response.data.map((test) => ({
            label: test.name,
            value: test.name,
            code: test.code,
            amount: test.amount,
          }));
          setTestOptions2(options);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching test options:", error);
        });
    };
    fetchLab();
  }, []);
  console.log("BookService - selectedPatient:", selectedPatient); // Debug log
  console.log("BookService - patientId:", selectedPatient?.patientId); // Debug log
  const parsedDate = whenAppointmentFromNav
    ? new Date(`${whenAppointmentFromNav}T00:00:00`)
    : new Date();
  const [dateRange, setDateRange] = useState([
    {
      startDate: parsedDate ? parsedDate : new Date(),
      endDate: parsedDate ? parsedDate : new Date(),
      key: "selection",
    },
  ]);

  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef();
  const [checkedLabDetails, setCheckedLabDetails] = useState([]);
  const [searchInput, setSearchInput] = useState(
    patientNameFromNav ? patientNameFromNav : "",
  );
  const [searchResults, setSearchResults] = useState([]);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [selectpatient, Setselectpatient] = useState(
    patientCodeFromNav ? patientCodeFromNav : "",
  );
  const [selectpatientdata, Setselectpatientdata] = useState(
    patientCodeFromNav ? patientCodeFromNav : "",
  );
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [currentUploadRow, setCurrentUploadRow] = useState(null);
  const hiddenFileInput = useRef(null);
  const fileInputRef = useRef(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const OCR_API_URL = process.env.REACT_APP_OCR_API_URL;
  const OCR_API_KEY = process.env.REACT_APP_OCR_API_KEY;
  const [mainData, setMainData] = useState({
    patientDrugPrescriptionList: [],
    patientLabTestsList: [],
    recommendation: "",
    surgeryRecommendation: "",
    symptoms: [],
    followUpVisitDate: null,
    diagnosis: null,
  });
  const [uploading, setUploading] = useState(false);
  const [scheduledPatients, setScheduledPatients] = useState([]);
  const [editingMedicineIdx, setEditingMedicineIdx] = useState(null);
  const [editingLabIdx, setEditingLabIdx] = useState(null);
  const [isUserTyping, setIsUserTyping] = useState(false);
  // New state to track medicines being processed (selected but not yet added to cart)
  const [processingMedicines, setProcessingMedicines] = useState(new Set());
  const [searchResultsdata, setSearchResultsdata] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [mainData2, setMainData2] = useState([]);
  const handleDeleteLab = (idx) => {
    setMainData((prev) => ({
      ...prev,
      patientLabTestsList: prev.patientLabTestsList.filter((_, i) => i !== idx),
    }));
  };
  const handleEditLab = (idx) => {
    const lab = mainData.patientLabTestsList[idx];
    setManualLabTest2(lab.labTestName);
    setEditingLabIdx(idx);
    setShowAddLabModal2(true);
  };
  const handleSaveMedicine = () => {
    // if (
    //   !newMedicine.name.trim() ||
    //   !newMedicine.composition.trim() ||
    //   !newMedicine.quantity ||
    //   !newMedicine.dosage.trim() ||
    //   !newMedicine.instructions.trim() ||
    //   !newMedicine.duration.trim() ||
    //   !newMedicine.type.trim()
    // ) {
    //   toast.error("All fields are mandatory. Please fill in all fields.");
    //   return;
    // }
    if (editingMedicineIdx !== null) {
      // update existing
      setMainData((prev) => {
        const meds = [...prev.patientDrugPrescriptionList];
        meds[editingMedicineIdx] = {
          ...meds[editingMedicineIdx],
          drugName: newMedicine.name,
          composition: newMedicine.composition,
          quantity: newMedicine.quantity,
          dosage: newMedicine.dosage,
          instruction:
            newMedicine.instructions === "Before Meal"
              ? "1"
              : newMedicine.instructions === "After Meal"
                ? "0"
                : "",
          duration: newMedicine.duration,
          route: newMedicine.route,
          medicineTypeOfSell: newMedicine.medicineTypeOfSell,
          medicineRate: newMedicine.medicineRate,
          drugCategory: newMedicine.drugCategory,
          drugCode: newMedicine.drugCode,
          prescriptionRequired: newMedicine.prescriptionRequired,
        };
        return { ...prev, patientDrugPrescriptionList: meds };
      });
    } else {
      // add new
      setMainData((prev) => ({
        ...prev,
        patientDrugPrescriptionList: [
          ...prev.patientDrugPrescriptionList,
          {
            drugName: newMedicine.name,
            composition: newMedicine.composition,
            quantity: newMedicine.quantity,
            dosage: newMedicine.dosage,
            instruction:
              newMedicine.instructions === "Before Meal"
                ? "1"
                : newMedicine.instructions === "After Meal"
                  ? "0"
                  : "",
            duration: newMedicine.duration,
            route: newMedicine.route,
            medicineTypeOfSell: newMedicine.medicineTypeOfSell,
            medicineRate: newMedicine.medicineRate,
            drugCategory: newMedicine.drugCategory,
            drugCode: newMedicine.drugCode,
            prescriptionRequired: newMedicine.prescriptionRequired,
          },
        ],
      }));
    }

    setNewMedicine({
      name: "",
      composition: "",
      medicineTypeOfSell: "",
      medicineRate: "",
      drugCategory: "",
      route: "",
      drugCode: "",
      prescriptionRequired: "",
      quantity: 1,
      dosage: "1-0-1",
    });
    setEditingMedicineIdx(null);
    setShowAddModal(false);
  };

  const handleSaveMedicinenew = () => {
    if (!newMedicine2 || !newMedicine2.name?.trim()) {
      toast.error("Medicine name is required.");
      return;
    }
    console.log(newMedicine2, "newMedicine2");
    setMainData2((prev) => [
      ...prev,
      {
        name: newMedicine2.name,
        composition: newMedicine2.composition,
        quantity: newMedicine2.quantity,
        dosage: newMedicine2.dosage,
        instruction:
          newMedicine2.instructions === "Before Meal"
            ? "1"
            : newMedicine2.instructions === "After Meal"
              ? "0"
              : "",
        duration: newMedicine2.duration,
        typeOfSell: newMedicine2.medicineTypeOfSell,
        medicineRate: newMedicine2.medicineRate,
        drugCategory: newMedicine2.drugCategory,
        drugCode: newMedicine2.drugCode,
        prescriptionRequired: newMedicine2.prescriptionRequired,
      },
    ]);

    setNewMedicine2({
      name: "",
      composition: "",
      medicineTypeOfSell: "",
      medicineRate: "",
      drugCategory: "",
      route: "",
      drugCode: "",
      prescriptionRequired: "",
      quantity: 1,
      dosage: "1-0-1",
    });

    setShowAddModal3(false);
  };

  const handleAddMedicinesFromModal = (selections) => {
    if (!selections?.length) return;

    const newEntries = selections.map(({ item, quantity }) => ({
      name: item.medicineName || "",
      composition: item.composition || item.drugsInfoComposition || "",
      quantity,
      dosage: "1-0-1",
      instruction: "",
      duration: "",
      typeOfSell: item.medicineTypeOfSell || "",
      medicineRate:
        getMedicineDisplayPrice(item) ?? item.medicineRate ?? "",
      salePrice: item.salePrice ?? "",
      unitPrice: item.unitPrice ?? "",
      drugCategory: item.drugCategory || "",
      drugCode: item.id || "",
      prescriptionRequired: item.prescriptionRequired || "",
    }));

    setMainData2((prev) => [...prev, ...newEntries]);
    setShowAddModal3(false);
    toast.success(
      `${newEntries.length} medicine${newEntries.length === 1 ? "" : "s"} added to order`,
    );
  };

  const existingOrderDrugIds = useMemo(() => {
    const codes = new Set(
      (mainData2 || []).map((m) => m.drugCode).filter(Boolean),
    );
    (medicinesData || []).forEach((m) => {
      if (m.drugCode) codes.add(m.drugCode);
    });
    return codes;
  }, [mainData2, medicinesData]);

  const prescriptionDrugNames = useMemo(
    () =>
      (medicinesData || [])
        .map((m) => m.name || m.drugName)
        .filter(Boolean),
    [medicinesData],
  );

  const handleAddLabTestsFromModal = (selections) => {
    if (!selections?.length) return;

    const existingKeys = new Set((tempSelectedLabs || []).map(getLabItemKey));
    const newLabs = selections
      .map((s) => s.item)
      .filter((item) => !existingKeys.has(getLabItemKey(item)));

    if (!newLabs.length) {
      toast.info("Selected tests are already in the order");
      setShowAddLabModal(false);
      return;
    }

    setTempSelectedLabs((prev) => [...prev, ...newLabs]);
    setShowAddLabModal(false);
    toast.success(
      `${newLabs.length} lab test${newLabs.length === 1 ? "" : "s"} added to order`,
    );
  };

  const existingOrderLabKeys = useMemo(() => {
    const keys = new Set((tempSelectedLabs || []).map(getLabItemKey));
    (labTestsData || []).forEach((lab) => {
      const code = lab.labTestId || lab.labTestCode;
      if (code) keys.add(String(code));
      keys.add(getLabItemKey(lab));
    });
    return keys;
  }, [tempSelectedLabs, labTestsData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };

    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCalendar]);

  const toggleMedicine = (id) => {
    setSelectedMedicines((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
    );
  };

  const toggleLab = (id) => {
    setSelectedLabs((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
    );
  };
  function toggleCheckedTempLab(code) {
    setCheckedLabDetails((prev) => {
      // if already checked, remove it
      if (prev.some((l) => l.labTestCode === code)) {
        return prev.filter((l) => l.labTestCode !== code);
      }
      // otherwise pull the full object out of tempSelectedLabs
      const lab = tempSelectedLabs.find((t) => t.labTestCode === code);
      return lab
        ? [
            ...prev,
            {
              labTestCode: lab.labTestCode,
              labId: lab.labId,
              locationId: lab.locationId,
              amount: lab.amount,
              labTestName: lab.labTestName,
            },
          ]
        : prev;
    });
  }
  const fetchPatientList = async (from, to) => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    const fromDate = format(from, "yyyy-MM-dd");
    const toDate = format(to, "yyyy-MM-dd");

    try {
      const response = await fetch(
        `${API_URL}queue/appointmentlist?clinicId=${clinicId}&status=COMPLETED&fromDate=${fromDate}&toDate=${toDate}&pageNumber=1&pageSize=10`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        },
      );
      const data = await response.json();
      setPatientList(Array.isArray(data) ? data : data?.data || []);

      // After fetching patient list, call fetchPrescription if we have current appointment details
      if (
        currentAppointmentDetails.appointmentId &&
        currentAppointmentDetails.whenAppointment
      ) {
        // Find the patient with matching appointment details
        const patient = data?.find(
          (p) =>
            p.appointmentId === currentAppointmentDetails.appointmentId &&
            p.whenAppointment === currentAppointmentDetails.whenAppointment,
        );

        if (patient) {
          // Call fetchPrescription with the stored appointment details
          await fetchPrescription(
            currentAppointmentDetails.appointmentId,
            patient,
          );
        }
      }
    } catch (error) {
      toast.error("Something went wrong.");
    }
  };

  const fetchPatientList2 = async (from, to) => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    const fromDate = format(from, "yyyy-MM-dd");
    const toDate = format(to, "yyyy-MM-dd");
    try {
      const response = await fetch(
        `${API_URL}queue/appointmentlist?clinicId=${clinicId}&status=COMPLETED&prescriptionStatus=Y&patientId=${selectpatient}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        },
      );
      const data = await response.json();
      setPatientList(Array.isArray(data) ? data : data?.data || []);
    } catch (error) {
      toast.error("Something went wrong.");
    }
  };

  const fetchCartList = async () => {
    if (!patientDetails.curebayPatientId) return;
    const token = localStorage.getItem("auth_token");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_CARTURL}common/cart-list/${patientDetails.curebayPatientId}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setCartList(data.data.carts || []);
    } catch (err) {
      setLabCartDetails(null);
      setCartList();

      console.error("Failed to fetch cart list:", err.response?.data || err);
    }
  };

  const fetchPatientdetails = async (patientid) => {
    console.log(patientid, "fcgvhbjnkghjkl");
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    // setMedicines([]);
    // const patientid=selectpatientdata || selectpatient
    try {
      const response = await axios.get(
        `${API_URL}patient/search?patientId=${patientid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        },
      );
      console.log(response.data, patientid, "zsxdcfvghbjcfvgbh");
      const firstPatient = response?.data.data[0];
      setPatientDetails(firstPatient);
    } catch (error) {
      console.error("Error fetching slots:", error);
    }
  };

  // useEffect(() => {
  //   const labCart = cartList.find((cart) => cart.type === "LAB");
  //   setLabCartDetails(labCart || {});
  // }, [cartList]);

  // useEffect(() => {
  //   fetchCartList();

  // }, [selectedPatient]);

  useEffect(() => {
    console.log(selectpatientdata, "selectpatient");
    if (selectpatientdata || selectpatient) {
      fetchPatientdetails(selectpatientdata);
    }
  }, [selectpatientdata]);

  useEffect(() => {
    setMedicines([]);
    fetchlabdetails2();
    fetchCartList();
    fetchCartData();
  }, [patientDetails]);

  useEffect(() => {
    if (selectpatient) {
      const { startDate, endDate } = dateRange[0];
      fetchPatientList2(startDate, endDate);
    } else {
      // no patient filter → hit calendar endpoint
      const { startDate, endDate } = dateRange[0];
      fetchPatientList(startDate, endDate);
    }
  }, [selectpatient, dateRange]);

  // useEffect(() => {
  //   fetchCartData();
  // }, [selectedPatient]);
  const fetchCartData = async () => {
    //  setMedicines([]);
    if (!patientDetails.curebayPatientId) {
      setLoading(false);
      setRemoveMedicineLoading(false); // Also stop remove medicine loader
      setAddMedicineLoading(false); // Also stop add medicine loader
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}medicine/details?patientId=${patientDetails.curebayPatientId}`,
      );
      const data = await response.json();
      if (data.status === "OK") {
        setMedicines(data.data.medicineItems || []);
      } else {
        setMedicines([]);
      }
    } catch (err) {
      setMedicines([]);
      console.error("Error fetching cart data:", err);
    } finally {
      setLoading(false);
      setRemoveMedicineLoading(false); // Stop remove medicine loader after fetchCartData completes
      setAddMedicineLoading(false); // Stop add medicine loader after fetchCartData completes
      // fetchCartList();
    }
  };
  useEffect(() => {
    // find the LAB cart entry
    fetchlabdetails();
  }, [cartList]);
  const fetchlabdetails = async () => {
    const labCart = cartList.find((c) => c.cartType === "LAB");
    if (!labCart) return;

    const token = localStorage.getItem("auth_token");
    axios
      .get(
        `${process.env.REACT_APP_CARTURL}lab/details?cartId=${labCart.cartId}`,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      .then((res) => {
        console.log("Lab cart details:", res.data.data);
        // setLabCartDetails(res.data.data);
      })
      .catch((err) => {
        console.error("Failed to fetch lab-cart details:", err.response || err);
        // setLabCartDetails();
      });
  };

  // useEffect(() => {
  //   fetchPatientList(new Date(), new Date());
  // }, []);

  const fetchPrescription = async (appointmentId, patient) => {
    Setselectpatientdata(patient.patientId);
    setTempSelectedLabs([]);
    // console.log(patient.patientId, "fgyhuijok");
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    try {
      const res = await fetch(
        `${API_URL}prescriptions/search?appointmentId=${appointmentId}&visitDate=${patient.whenAppointment}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        },
      );

      const data = await res.json();
      const prescription = data?.data?.[0];

      setAbdmData(prescription);
      console.log(prescription, "ygbubuhnijnj");
      if (prescription) {
        setSelectedPatient({
          ...patient,
          ...(prescription.prescription || {}),
          ...(prescription.prescription && {
            prescriptionId: prescription.prescription.id,
          }),
        });
        console.log(selectedPatient, "fgcfgcgvvhjvh");
        setMedicinesData(
          (prescription.prescription.patientDrugPrescriptionList || []).map(
            (item, i) => ({
              id: i + 1,
              name: item.drugName,
              composition: item.composition,
              quantity: item.quantity,
              isManual: false,
              ...item,
            }),
          ),
        );
        setLabTestsData(
          (prescription.prescription.patientLabTestsList || []).map(
            (item, i) => ({
              id: i + 1,
              name: item.labTestName,
              price: `₹${item.amount}`,
              ...item,
            }),
          ),
        );
      } else {
        // When prescription is null, still merge the other fields from the API response
        setSelectedPatient({ ...patient, ...prescription });
        setMedicinesData([]);
        setLabTestsData([]);
      }
    } catch (err) {
      // toast.error("Error fetching prescription.");
    }
  };

  const handleAddToCart = async (medicineId) => {
    const selectedMedicine = medicinesData.find(
      (m) => m.drugCode === medicineId,
    );
    setLoadingMedicines2((prev) => new Set(prev).add(medicineId));
    setAddMedicineLoading(true); // Start page loader

    console.log(selectedMedicine, "selectedMedicine");
    if (!selectedMedicine || !selectedPatient) {
      toast.error("Medicine or Patient not found");
      setLoadingMedicines((prev) => {
        const updated = new Set(prev);
        updated.delete(medicineId);
        return updated;
      });
      return;
    }
    try {
      // Check if patient needs to be registered first
      if (patientDetails.curebayPatientId == null) {
        // toast.info("Registering patient...");

        // Step 1 & 2: Register patient and update with curebayPatientId
        const registrationResult = await handleregister();
        // toast.success("Patient registered and updated successfully");

        // console.log("Registration completed:", registrationResult);
      }

      const payload = {
        // patientId: selectedPatient.patientId,
        patientId: patientDetails.curebayPatientId,
        drugCode: selectedMedicine.drugCode || "",
        drugName: selectedMedicine.drugName || selectedMedicine.name,
        drugCategory: selectedMedicine.drugCategory || "RX",
        medicineTypeOfSell: selectedMedicine.typeOfSell || "",
        medicineType: selectedMedicine.medicineType || "",
        unitPrice: parseFloat(selectedMedicine.rate) || 0,
        // parseFloat(selectedMedicine.rate * selectedMedicine.quantity) || 0,
        quantity: parseInt(selectedMedicine.quantity) || 1,
        prescriptionRequired:
          selectedMedicine?.prescriptionRequired == "No" ? false : true,
        preferredMedicine: "Y",
        cartType: "MED",
        sourceChannel: "B2C",
        drugsInfoComposition: selectedMedicine?.composition,
      };

      try {
        const response = await fetch(
          `${process.env.REACT_APP_CARTURL}medicine/add`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
            },
            body: JSON.stringify(payload),
          },
        );

        const result = await response.json();
        await fetchCartList();
        await fetchCartData();
        console.log("✅ Cart API Response:", result);

        if (response.ok) {
          setCartId(result.data.cartId);
          setCartEntryIds((prev) => ({
            ...prev,
            [medicineId]: result.data.id, // ← THIS is the 38491
          }));
          setSelectedMedicines((prev) => {
            if (prev.includes(medicineId)) return prev;
            return [...prev, medicineId];
          });
          // Remove from processing medicines when successfully added to cart
          setProcessingMedicines((prev) => {
            const updated = new Set(prev);
            updated.delete(medicineId);
            return updated;
          });
          toast.success("Medicine added to cart");
        } else {
          toast.error(result.message || "Failed to add medicine");
        }
      } catch (error) {
        console.error("Cart API Error:", error);
        toast.error("Something went wrong while adding to cart");
      } finally {
        setLoadingMedicines2((prev) => {
          const updated = new Set(prev);
          updated.delete(medicineId);
          return updated;
        });
      }
    } catch (error) {
      console.error("Error:", error);
      if (
        error.message.includes("Registration") ||
        error.message.includes("update")
      ) {
        toast.error("Failed to register/update patient: " + error.message);
      } else {
        toast.error("Something went wrong while adding to cart");
      }
    } finally {
      setAddMedicineLoading(false);
    }
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const handleregister = async () => {
    console.log(patientDetails, "patientDetails");
    const tenantId = localStorage.getItem("tenantId");
    try {
      // Step 1: Patient Registration
      const token = localStorage.getItem("access_token");
     

      const firstName = localStorage.getItem("firstName");
      const lastName = localStorage.getItem("lastName");
      const payload = {

salutation: patientDetails.salutation,
  mobileNumber: patientDetails.mobileNumber,
  firstName: patientDetails.firstName,
  lastName: patientDetails.lastName,
  email: "",
  password: "Test@123",
  dob: formatDate(patientDetails.dob),
  gender:  patientDetails.gender == "male"
  ? "M"
  : patientDetails.gender == "female"
    ? "F"
    : "O",
  address1: patientDetails.address,
  address2: patientDetails.address,
  pincode: patientDetails.pinCode,
  city: "",
  state: patientDetails.state,
  country: "India",
  privacyPolicy: "Y",
  termsCondition: "Y",
  source: "HOSPI360",
  hospitalId: localStorage.getItem("hospitalid"),
  createdBy: firstName +" "+ lastName,
  modifiedBy: firstName +" "+ lastName,



       
      };
      console.log(payload, "payloadjhbkj");

      const registerResponse = await fetch(
        `${process.env.REACT_APP_API_URL_PATIENTS}patient-user/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        },
      );

      console.log(registerResponse.status, "registration status");
      const registerResult = await registerResponse.json();
      console.log(registerResult, "registration response data");
      if (registerResponse.status === 200) {
       

        // Step 2: Update Patient with curebayPatientId
        const authToken = localStorage.getItem("auth_token");
        const updatePayload = {
          firstName: patientDetails.firstName,
          lastName: patientDetails.lastName,
          gender: patientDetails.gender,
          mobileNumber: patientDetails.mobileNumber, // Fixed: was patient.mobileNumber
          curebayPatientId:
            registerResult.data?.patientCode ,
        };

        const updateResponse = await fetch(
          `${API_URL}patient/update/${patientDetails.patientCode}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
              tenantId: tenantId,
            },
            body: JSON.stringify(updatePayload),
          },
        );

        if (updateResponse.ok) {
          const updateResult = await updateResponse.json();
          console.log(updateResult, "update response data");

          // Update local patientDetails
          patientDetails.curebayPatientId = updatePayload.curebayPatientId;
          fetchPatientdetails(patientDetails.patientCode);
          return {
            registration: registerResult,
            update: updateResult,
            curebayPatientId: updatePayload.curebayPatientId,
          };
        } else {
          const updateError = await updateResponse.json();
          throw new Error(updateError.message || "Patient update failed");
        }
      } else {
        const registerError = await registerResponse.json();
        throw new Error(registerError.message || "Registration failed");
      }
    } catch (error) {
      console.error("Registration process error:", error);
      throw error;
    }
  };
  const handleAddToCart2 = async (medicineId) => {
    setAddMedicineLoading(true);
    if (patientDetails.curebayPatientId == null) {
      // handleregister();
      const registrationResult = await handleregister();
    }
    setLoadingMedicines((prev) => new Set(prev).add(medicineId));
    // Start page loader

    const selectedMedicine = mainData2.find((m) => m.drugCode === medicineId);
    if (!selectedMedicine || !selectedPatient) {
      toast.error("Medicine or Patient not found");
      setLoadingMedicines((prev) => {
        const updated = new Set(prev);
        updated.delete(medicineId);
        return updated;
      });
      return;
    }
    console.log(selectedMedicine, "selectedMedicinehgbh");
    const payload = {
      // patientId: selectedPatient.patientId,
      patientId: patientDetails.curebayPatientId,
      drugCode: selectedMedicine.drugCode || "",
      drugName: selectedMedicine.drugName || selectedMedicine.name,
      drugCategory: selectedMedicine.drugCategory || "RX",
      medicineTypeOfSell: selectedMedicine.typeOfSell || "",
      medicineType: selectedMedicine.medicineType || "",
      unitPrice: parseFloat(selectedMedicine.medicineRate) || 0,
      quantity: parseInt(selectedMedicine.quantity) || 1,
      prescriptionRequired:
        selectedMedicine?.prescriptionRequired == "No" ? false : true,
      preferredMedicine: "Y",
      cartType: "MED",
      sourceChannel: "B2C",
      drugsInfoComposition: selectedMedicine?.composition,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}medicine/add`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();
      await fetchCartData();
      await fetchCartList();
      if (response.ok) {
        setCartId(result.data.cartId);
        setCartEntryIds((prev) => ({
          ...prev,
          [medicineId]: result.data.id,
        }));
        setSelectedMedicines((prev) =>
          prev.includes(medicineId) ? prev : [...prev, medicineId],
        );
        // Remove from processing medicines when successfully added to cart
        setProcessingMedicines((prev) => {
          const updated = new Set(prev);
          updated.delete(medicineId);
          return updated;
        });
        toast.success("Medicine added to cart");
      } else {
        toast.error(result.message || "Failed to add medicine");
      }
    } catch (error) {
      console.error("Cart API Error:", error);
      toast.error("Something went wrong while adding to cart");
    } finally {
      setLoadingMedicines((prev) => {
        const updated = new Set(prev);
        updated.delete(medicineId);
        return updated;
      });
    }
  };

  //    const handleAddToCart2 = async (medicineId) => {

  //    const selectedMedicine = mainData2.find((m) => m.drugCode === medicineId);
  //  console.log(selectedMedicine,mainData2,"medicineIds")
  //     if (!selectedMedicine || !selectedPatient) {
  //       toast.error("Medicine or Patient not found");
  //       return;
  //     }

  //     const payload = {
  //       patientId: selectedPatient.patientId,
  //       drugCode: selectedMedicine.drugCode || "",
  //       drugName: selectedMedicine.drugName || selectedMedicine.name,
  //       drugCategory: selectedMedicine.drugCategory || "RX",
  //       medicineTypeOfSell: selectedMedicine.typeOfSell || "",
  //       medicineType: selectedMedicine.medicineType || "",
  //       unitPrice:  parseFloat(selectedMedicine.medicineRate) || 0,
  //         // parseFloat(selectedMedicine.rate * selectedMedicine.quantity) || 0,
  //       quantity: parseInt(selectedMedicine.quantity) || 1,
  //       prescriptionRequired: false,
  //       preferredMedicine: "Y",
  //       cartType: "MED",
  //       sourceChannel: "B2C",
  //     };

  //     console.log(payload,"payload")
  //     try {
  //       const response = await fetch(
  //         `${process.env.REACT_APP_CARTURL}medicine/add`,
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
  //           },
  //           body: JSON.stringify(payload),
  //         }
  //       );

  //       const result = await response.json();
  //       await fetchCartData();
  //       console.log("✅ Cart API Response:", result);

  //       if (response.ok) {
  //         setCartId(result.data.cartId);
  //         setCartEntryIds((prev) => ({
  //           ...prev,
  //           [medicineId]: result.data.id, // ← THIS is the 38491
  //         }));
  //         setSelectedMedicines((prev) => {
  //           if (prev.includes(medicineId)) return prev;
  //           return [...prev, medicineId];
  //         });
  //         toast.success("Medicine added to cart");
  //       } else {
  //         toast.error(result.message || "Failed to add medicine");
  //       }
  //     } catch (error) {
  //       console.error("Cart API Error:", error);
  //       toast.error("Something went wrong while adding to cart");
  //     }
  //   };

  const handleRemoveMedicine = async (medicineId) => {
    if (!patientDetails.curebayPatientId || !cartId) return;

    const entryId = cartEntryIds[medicineId];
    if (!entryId) {
      console.warn("No server entry ID for", medicineId);
      return;
    }

    setRemovingItems((prev) => new Set(prev).add(medicineId));
    setRemoveMedicineLoading(true); // Start page loader

    try {
      const res = await fetch(
        `${process.env.REACT_APP_CARTURL}medicine/removeMedicine`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            cartId: cartId,
            id: entryId, // ← use the server's 38491
            patientId: patientDetails.curebayPatientId,
          }),
        },
      );
      const result = await res.json();

      if (!res.ok) throw new Error(result.message || "Failed to remove");

      // remove locally
      setSelectedMedicines((prev) => prev.filter((id) => id !== medicineId));
      toast.success("Removed from cart");

      // clean up your map
      setCartEntryIds((prev) => {
        const next = { ...prev };
        delete next[medicineId];
        return next;
      });
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Could not remove medicine");
    } finally {
      setRemovingItems((prev) => {
        const next = new Set(prev);
        next.delete(medicineId);
        return next;
      });
    }
  };

  const handleManualAdd = () => {
    setMedicinesData((prev) => [
      ...prev,
      { id: Date.now(), ...newMedicine, isManual: true },
    ]);
    setShowAddModal(false);
    setNewMedicine({ name: "", composition: "", quantity: 1 });
  };

  const handleUploadPrescription = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageURL = URL.createObjectURL(file);
      setUploadedPrescription(file);
      setPreviewImageURL(imageURL);
      setPreviewModalOpen(true);
    }
  };
  const handleAutoCompleteChange = (e) => {
    setManualLabTest(e.value); // ✅ Fix: Allow users to type freely
  };
  useEffect(() => {
    const medBill = medicinesData.reduce((acc, item) => {
      if (selectedMedicines.includes(item.id)) {
        const quantity = parseInt(item.quantity) || 0;
        const amount = parseFloat(item.rate) || 0;
        return acc + quantity * amount;
      }
      return acc;
    }, 0);
    setMedicineBill(medBill);

    const labBill = checkedLabDetails.reduce((acc, item) => {
      const price = parseFloat(item.amount) || 0;
      return acc + price;
    }, 0);

    console.log("Final Lab Bill:", labBill); // ✅ ADD THIS

    setLabTestBill(labBill);
    setTotalAmount(medBill + labBill);
  }, [medicinesData, tempSelectedLabs, selectedMedicines, checkedLabDetails]);

  const handleProceed = async () => {
    const token = localStorage.getItem("auth_token");
    const selectedMedicineDetails = medicinesData.filter((med) =>
      selectedMedicines.includes(med.id),
    );

    const selectedLabDetails = labTestsData.filter((lab) =>
      selectedLabs.includes(lab.id),
    );
    console.log(selectedMedicineDetails, selectedLabDetails, "fcgvhjiko");
    const clinicId = localStorage.getItem("clinicId");
    const hospitalIds = new Set(checkedLabDetails.map((d) => d.labId));
    if (hospitalIds.size > 1) {
      toast.error(
        "Select all test from the same lab or replace the tests in your cart",
      );
      return;
    }

    const payload = {
      clinicId: clinicId,
      // appointmentObjectId: selectedPatient?.id,
      patientPrescriptionObjectId: selectedPatient?.id,
      patientName: selectedPatient?.patientName,
      orderPlacedTo: "SMART_CLINIC",
      patientMobileNo: selectedPatient?.patientMobileNo || "",
      txnId: "",
      appointmentId: selectedPatient?.appointmentId,
      patientId: selectedPatient?.patientId,
      patientLabTestsList: checkedLabDetails.map((item) => ({
        labTestId: item.labId || "",
        labTestName: item.labTestName,
        status: 1,
        amount: item.amount,
        discountedAmount: "",
      })),
      patientDrugPrescriptionList: selectedMedicineDetails.map((item) => ({
        composition: item.composition,
        afterBeforeFood: item.afterBeforeFood,
        type: item.type,
        dosage: item.dosage,
        drugName: item.drugName,
        drugName1: item.drugName1,
        duration: item.duration,
        drugCategory: item.drugCategory,
        form: item.form,
        frequency: item.frequency,
        instruction: item.instruction,
        medicineType: item.medicineType,
        pharmacyStockId: item.pharmacyStockId,
        drugMType: item.drugMType,
        quantity: item.quantity,
        specialAuthority: item.specialAuthority,
        status: 1,
        drugCode: item.drugCode,
        drugType: item.drugType,
        amount: item.rate,
        typeOfSell: item.typeOfSell,
        notes: item.notes,
        rate: item.rate,
        discountedAmount: item.discountedAmount,
      })),
      appoimentDetails: [],
      amount: 0,
      discountedAmount: 0,
    };
    console.log(payload, selectedPatient, "payload");

    // try {
    //   const response = await fetch(`${API_URL}orders/save`, {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //     },
    //     body: JSON.stringify(payload),
    //   });

    //   const result = await response.json();
    //   console.log(result, "result");
    //   if (result.status === 200) {
    //     setorderid(result.data?.id);
    //     // toast.success(result.message || "Order submitted successfully");
    //     setModalOpen(true);
    //   } else {
    //     toast.error(result.message || "Order submission failed");
    //   }
    // } catch (error) {
    //   toast.error("Something went wrong while submitting order");
    // }
  };

  const handlePay = async () => {
    if (paymentMode === "CASH") {
      // await confirmAppointment("CASH");
    }
  };

  // Handle cart click from header
  const handleCartClick = () => {
    if (cartItemCount > 0) {
      const cartItems = [];
      if (selectedMedicines.length > 0) {
        cartItems.push(`${selectedMedicines.length} medicines`);
      }
      if (selectedLabs.length > 0) {
        cartItems.push(`${selectedLabs.length} lab tests`);
      }
    } else {
    }
  };
  const searchTests2 = (event) => {
    const query = event.query.toLowerCase();
    setManualLabTest2(event.query); // ✅ Fix: Store user input
    const filtered = testOptions2.filter((option) =>
      option.label.toLowerCase().includes(query),
    );
    console.log(filtered, "erdtfgyuhji");
    setFilteredOptions(filtered);
  };
  const searchTests = async (event) => {
    const query = event.query.toLowerCase();
    if (query.length < 3) {
      setTestOptions([]); // optionally clear dropdown
      return;
    }
    setLoading(true);
    const response = await axios
      .get(
        // `${process.env.REACT_APP_API_URL_DOCTOR}DiagnosticsLabTests/list/filter?parentId=0&status=1`
        // `partner-labs?labCategory=LAB&freeTextSearch=${event.query}&circle=PURI`
        `${process.env.REACT_APP_DIAGNOSISURL}partner-labs/searchByPinCode?labCategory=LAB&freeTextSearch=${event.query}&pincode=751009`,
      )
      .then((response) => {
        // const options = response.data.content.map((test) => ({
        //   ...test,
        //   label: test.labTestName,
        //   value: test.labTestName,
        //   labTestCode: test.labTestCode,
        // }));
        console.log(response.data, "edetfrgyhj");
        const options = response.data.content.map((test) => ({
          ...test,
          label: test.displayName,
          value: test.displayName,
          labTestCode: test.partnerTestCode,
        }));
        console.log(response.data, options, "edetfrgyhj");
        setTestOptions(options);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching test options:", error);
      });
    // const query = event.query.toLowerCase();
    // setManualLabTest(event.query); // ✅ Fix: Store user input
    // const filtered = testOptions.filter((option) =>
    //   option.label.toLowerCase().includes(query)
    // );
    // console.log(filtered, "erdtfgyuhji");
    // setFilteredOptions(filtered);
  };
  const handleSaveLabTests = () => {
    console.log(selectedLab, "selectedLab");
    // 1) Add to permanent list
    setTempSelectedLabs((prev) => [...prev, selectedLab]);

    // 2) Also add into your billing payload list
    // setLabTestsData((prev) => [
    //   ...prev,
    //   ...selectedLab.map((t, i) => ({
    //     id: Date.now() + i,
    //     labTestCode: t.code,
    //     name: t.label,
    //     amount: t.amount,
    //     price: `₹${t.amount}`,
    //     labName: t.labName,
    //     isManual: true,
    //   })),
    // ]);

    // 3) Clear staging & close
    setSelectedLab([]);
    setManualLabTest("");
    setShowAddLabModal(false);
  };

  const existingLabCodes = useMemo(() => {
    console.log(labCartDetails, "labCartDetails");
    return labCartDetails?.hospitalId || [];
  }, [labCartDetails]);

  // somewhere near the top of your component
  // const existingLabTestCodes = useMemo(() => {
  //   return new Set(
  //     (labCartDetails?.labTestItems || []).map((item) => item.labTestCode)
  //   );
  // }, [labCartDetails,cartList]);

  const existingLabTestCodes = useMemo(() => {
    console.log(labCartDetails, "labCartDetails");
    const codes = (labCartDetails?.labTestItems || []).map(
      (item) => item.labTestCode,
    );
    return new Set(codes);
  }, [labCartDetails, cartList]);

  const existingmedicineCodes = useMemo(() => {
    return new Set((medicines || []).map((item) => item.drugId));
  }, [medicines]);

  const cartHospitalId = labCartDetails?.hospitalId;
  // useEffect(() => {
  //   if (labCartDetails?.labTestItems?.length > 0) {
  //     const entryMap = {};
  //     const idList = [];

  //     labCartDetails.labTestItems.forEach((test) => {
  //       if (test.id) {
  //         entryMap[test.testId] = test.id;
  //         idList.push(test.testId);
  //       }
  //     });

  //     setLabCartEntryIds(entryMap);
  //     setSelectedLabTests(idList);
  //   }
  // }, [labCartDetails]);

  const handleAddLabToCart = async (detail) => {
    const labId = detail.partnerTestCode;
    setLoadingLabIds((prev) => ({ ...prev, [labId]: true }));

    if (cartHospitalId && cartHospitalId !== detail.diagnosticsCode) {
      toast.error(
        "Select this test from the same lab or replace the tests in your cart",
      );
      setLoadingLabIds((prev) => ({ ...prev, [labId]: false }));
      return;
    }

    try {
      const payload = {
        // patientId: selectedPatient.patientId,
        patientId: patientDetails.curebayPatientId,
        labTestCode: detail?.partnerTestCode,
        amount: detail?.listPrice,
        hospitalId: detail?.diagnosticsCode,
        locationId: detail?.locationCode,
        labTestName: detail?.partnerTestName,
        labTestType: detail?.labType,
        sourceChannel: "B2C",
        sampleType: detail?.sampleType,
        sampleColor: detail?.sampleColor,
        vialType: detail?.vialType,
        vialsColour: detail?.vialColor,
        vials: detail?.noOfVials,
        sampleVolume: detail?.sampleVolume,
        schedule: detail?.schedule,
        testFor: detail?.testFor,
        testCount: detail?.testCount,
        testParameters: detail?.testParameters,
        category: detail?.category,
        method: detail?.method,
        preTestInfo: detail?.preTestInfo,
        howToRead: detail?.howToRead,
        imageUrls: detail?.imageUrls,
        icon: detail?.icon,
        componentCovered: detail?.componentCovered,
        intrResult: detail?.intrResult,
        cbTestCode: detail?.curebayTestCode,
      };

      const token = localStorage.getItem("auth_token");
      const response = await axios.post(
        `${process.env.REACT_APP_CARTURL}lab/add`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = response.data;
      await fetchCartList();
      await fetchlabdetails2();

      setLabCartEntryIds((prev) => ({
        ...prev,
        [labId]: result.data.id,
      }));
      setSelectedLabTests((prev) => [...prev, labId]);
      toast.success("Lab test added to cart");
    } catch (err) {
      console.error("Add to cart failed", err);
      toast.error(err?.response?.data?.message || "Add to cart failed");
    } finally {
      setTimeout(() => {
        setLoadingLabIds((prev) => ({ ...prev, [labId]: false }));
      }, 600);
    }
  };
  const cartlabEntryMap = useMemo(() => {
    const map = new Map();
    (labCartDetails?.labTestItems || []).forEach((item) => {
      map.set(item.labTestCode, item.id); // drugCode === drugId
    });
    return map;
  }, [labCartDetails]);
  const handleRemoveLab = async (details) => {
    const cartItemId = cartlabEntryMap.get(details.partnerTestCode);
    if (!patientDetails.curebayPatientId || !cartItemId) return;

    setLoadingLabIds((prev) => ({ ...prev, [details.partnerTestCode]: true }));

    try {
      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}lab/removeLab`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cartId: cartList.find((c) => c.cartType === "LAB")?.cartId,
            id: cartItemId,
            patientId: patientDetails.curebayPatientId,
          }),
        },
      );
      if (response.ok) {
        try {
          //   await fetchCartList();
          //  await fetchlabdetails();
          await fetchlabdetails2();

          // These will only execute after both API calls are complete
          setSelectedLabTests((prev) =>
            prev.filter((id) => id !== details.partnerTestCode),
          );
          setLabCartEntryIds((prev) => {
            const updated = { ...prev };
            delete updated[details.partnerTestCode];
            return updated;
          });
          toast.success("Lab test removed");
        } catch (fetchError) {
          console.error("Error fetching updated data:", fetchError);
          toast.error("Lab test removed but failed to refresh data");
        }
      } else {
        toast.error("Failed to remove lab test");
      }
      // if (response.ok) {
      //   await fetchCartList();
      //   await fetchlabdetails();
      //   setSelectedLabTests((prev) => prev.filter((id) => id !== details.partnerTestCode));
      //   setLabCartEntryIds((prev) => {
      //     const updated = { ...prev };
      //     delete updated[details.partnerTestCode];
      //     return updated;
      //   });
      //   toast.success("Lab test removed");
      // } else {
      //   toast.error("Failed to remove lab test");
      // }
    } catch (error) {
      console.error("Error removing lab test:", error);
      toast.error("Error removing lab test");
    } finally {
      setTimeout(() => {
        setLoadingLabIds((prev) => ({
          ...prev,
          [details.partnerTestCode]: false,
        }));
      }, 700);
    }
  };

  const handleRemoveLab2 = async (details) => {
    console.log(details.labTestCode, "sedrftgyhujk");
    const cartItemId = cartlabEntryMap.get(details.labTestCode);
    if (!patientDetails.curebayPatientId || !cartItemId) return;

    setLoadingLabIds((prev) => ({ ...prev, [details.partnerTestCode]: true }));

    try {
      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}lab/removeLab`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cartId: cartList.find((c) => c.cartType === "LAB")?.cartId,
            id: cartItemId,
            patientId: patientDetails.curebayPatientId,
          }),
        },
      );
      if (response.ok) {
        try {
          //   await fetchCartList();
          //  await fetchlabdetails();
          await fetchlabdetails2();

          // These will only execute after both API calls are complete
          setSelectedLabTests((prev) =>
            prev.filter((id) => id !== details.partnerTestCode),
          );
          setLabCartEntryIds((prev) => {
            const updated = { ...prev };
            delete updated[details.partnerTestCode];
            return updated;
          });
          toast.success("Lab test removed");
        } catch (fetchError) {
          console.error("Error fetching updated data:", fetchError);
          toast.error("Lab test removed but failed to refresh data");
        }
      } else {
        toast.error("Failed to remove lab test");
      }
      // if (response.ok) {
      //   await fetchCartList();
      //   await fetchlabdetails();
      //   setSelectedLabTests((prev) => prev.filter((id) => id !== details.partnerTestCode));
      //   setLabCartEntryIds((prev) => {
      //     const updated = { ...prev };
      //     delete updated[details.partnerTestCode];
      //     return updated;
      //   });
      //   toast.success("Lab test removed");
      // } else {
      //   toast.error("Failed to remove lab test");
      // }
    } catch (error) {
      console.error("Error removing lab test:", error);
      toast.error("Error removing lab test");
    } finally {
      setTimeout(() => {
        setLoadingLabIds((prev) => ({
          ...prev,
          [details.partnerTestCode]: false,
        }));
      }, 700);
    }
  };

  const fetchlabdetails2 = async () => {
    //  const labCart = cartList.find((c) => c.cartType === "LAB");
    //     if (!labCart) return;

    const token = localStorage.getItem("auth_token");
    axios
      .get(
        `${process.env.REACT_APP_CARTURL}lab/details?patientId=${patientDetails.curebayPatientId}`,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      .then((res) => {
        console.log("Lab cart details22:", res.data.data);
        setLabCartDetails(res.data.data);
      })
      .catch((err) => {
        console.error("Failed to fetch uyghjkhjknjkkn", err.response || err);
        setLabCartDetails(null);
      });
  };

  // const handleAddLabToCart = async (detail) => {
  //   console.log(existingLabCodes, detail, cartHospitalId,"edtrfgyuhji");
  //   if (cartHospitalId && cartHospitalId !== detail.diagnosticsCode) {
  //     return toast.error(
  //       "  Select this test from the same lab or replace the tests in your cart"
  //     );
  //   }

  //   const token = localStorage.getItem("auth_token");
  //   try {
  //     const payload = {
  //       patientId: selectedPatient.patientId,
  //       labTestCode: detail?.partnerTestCode,
  //       amount: detail?.listPrice,
  //       hospitalId: detail?.diagnosticsCode,
  //       locationId: detail?.locationCode,
  //       labTestName: detail?.partnerTestName,
  //       labTestType: detail?.labType,
  //       sourceChannel: "B2C",
  //       sampleType: detail?.sampleType,
  //       sampleColor: detail?.sampleColor,
  //       vialType: detail?.vialType,
  //       vialsColour: detail?.vialColor,
  //       vials: detail?.noOfVials,
  //       sampleVolume: detail?.sampleVolume,
  //       schedule: detail?.schedule,
  //       testFor: detail?.testFor,
  //       testCount: detail?.testCount,
  //       testParameters: detail?.testParameters,
  //       category: detail?.category,
  //       method: detail?.method,
  //       preTestInfo: detail?.preTestInfo,
  //       howToRead: detail?.howToRead,
  //       imageUrls: detail?.imageUrls,
  //       icon: detail?.icon,
  //       componentCovered: detail?.componentCovered,
  //       intrResult: detail?.intrResult,
  //     };
  //     console.log(detail, "xdcfvgbhnj");
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_CARTURL}lab/add`,
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     // ✅ no response.json(), axios unwraps JSON for you
  //     const result = response.data;
  //     await fetchCartList();
  //     toast.success("Lab test added to cart");

  //     console.log(result, "dfghjkl");

  //     // on success, remember that this code is in cart
  //     // setAddedLabCodes((prev) => [...prev, detail.labTestCode]);
  //   } catch (err) {
  //     console.error("Add to cart failed", err);
  //     console.log(err.response.data.message,"dxcfgvhbjnk")
  //      toast.error(err.response.data.message);
  //     // you may want to show a toast/error message here
  //   }
  // };

  const handleRemoveLabFromCart = async (labId) => {
    const entryId = cartEntryIds[`lab-${labId}`];
    if (!entryId || !patientDetails.curebayPatientId) return;

    setRemovingLabs((prev) => new Set(prev).add(labId));

    try {
      const res = await fetch(
        `${process.env.REACT_APP_CARTURL}lab/remove`, // or same remove endpoint
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            cartId,
            id: entryId,
            patientId: patientDetails.curebayPatientId,
          }),
        },
      );
      const result = await res.json();
      if (!res.ok) throw new Error(result.message || "Failed to remove");

      setSelectedLabs((prev) => prev.filter((id) => id !== labId));
      // clean up
      setCartEntryIds((prev) => {
        const next = { ...prev };
        delete next[`lab-${labId}`];
        return next;
      });
      toast.success("Lab test removed");
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Could not remove lab test");
    } finally {
      setRemovingLabs((prev) => {
        const next = new Set(prev);
        next.delete(labId);
        return next;
      });
    }
  };
  const handleMedicineClick2 = () => {
    // navigate("/LabCartPage", {
    //   state: {
    //     patientId: selectedPatient?.patientId,
    //     selectedPatient, // you can give it any key name you like
    //   },
    // });
    setCartOpen(true);
  };
  console.log(testOptions, "testOptions");
  // useEffect(() => {
  //   const delayDebounce = setTimeout(() => {
  //     if (searchInput.trim().length >= 3) {
  //       handleSearch();
  //     } else {
  //       setSearchResults([]);
  //     }
  //   }, 500); // 500ms debounce

  //   return () => clearTimeout(delayDebounce); // cleanup
  // }, [searchInput]);

  // const handleChange = (e) => {
  //   const value = e.target.value;
  //   setSearchInput(value);

  //   // Clear previous timeout if user is still typing
  //   if (typingTimeoutRef.current) {
  //     clearTimeout(typingTimeoutRef.current);
  //   }

  //   // Reset selected patient if input is empty
  //   if (value.trim() === "") {
  //     Setselectpatient(null);
  //     setSearchResults([]); // Optional: clear search results
  //     return;
  //   }

  //   // Debounce API call only when input length >= 3
  //   if (value.trim().length >= 3) {
  //     typingTimeoutRef.current = setTimeout(() => {
  //       handleSearch(value.trim());
  //     }, 500); // 500ms debounce
  //   }
  // };

  // const handleSearch = async () => {
  //   const token = localStorage.getItem("auth_token");
  //   const tenantId = localStorage.getItem("tenantId");
  //   const input = searchInput.trim();

  //   // Check if input is a number (mobile) or not (name)
  //   const isMobile = /^[0-9]+$/.test(input);
  //   const searchParam = isMobile
  //     ? `mobileNumber=${input}`
  //     : `firstName=${input}`;

  //   const url = `${API_URL}patient/search?${searchParam}`;

  //   try {
  //     const res = await fetch(url, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         tenantId: tenantId,
  //       },
  //     });

  //     const data = await res.json();

  //     if (Array.isArray(data)) {
  //       setSearchResults(data);
  //       setIsSearchModalOpen(true);
  //     } else {
  //       setSearchResults([]);
  //       toast.error("No patient found.");
  //     }
  //   } catch (error) {
  //     console.error("Search error:", error);
  //     toast.error("Something went wrong while searching.");
  //   }
  // };
  const handleChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);

    // Clear previous timeout if user is still typing
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    // Reset selected patient if input is empty
    if (value.trim() === "") {
      Setselectpatient(null);
      setSearchResults([]);
      return;
    }

    // Debounce API call only when input length >= 3
    if (value.trim().length >= 3) {
      typingTimeoutRef.current = setTimeout(() => {
        handleSearch(value.trim()); // Pass the current value directly
      }, 500);
    }
  };

  // Update handleSearch to accept a parameter
  const handleSearch = async (inputValue = null) => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const input = inputValue || searchInput.trim(); // Use passed value or fallback to state

    // Check if input is a number (mobile) or not (name)
    const isMobile = /^[0-9]+$/.test(input);
    const searchParam = isMobile
      ? `mobileNumber=${input}`
      : `firstName=${input}`;

    const url = `${API_URL}patient/search?${searchParam}`;

    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });

      const data = await res.json();

      if (Array.isArray(data.data)) {
        setSearchResults(data.data);
        setIsSearchModalOpen(true);
      } else {
        setSearchResults([]);
        toast.error("No patient found.");
      }
    } catch (error) {
      console.error("Search error:", error);
      toast.error("Something went wrong while searching.");
    }
  };
  console.log(searchResults, "medicinesData");
  function getAge(dobString) {
    const dob = new Date(dobString);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    // if birthday hasn't occurred yet this year, subtract 1
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  }
  // const handleUploadClick = (appointmentId, item, rowIndex) => {
  //   setSelectedAppointmentId(appointmentId);
  //   setCurrentUploadRow(rowIndex);
  //   if (hiddenFileInput.current && hiddenFileInput.current[rowIndex]) {
  //     hiddenFileInput.current[rowIndex].value = null; // reset file input
  //     hiddenFileInput.current[rowIndex].click();
  //   }
  // };

  console.log(selectedPatient, "selectedPatient");
  const handleUploadClick = () => {
    console.log("first");
    fileInputRef.current?.click();
  };

  const handlePrescriptionUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadedFile(file);
    const url = URL.createObjectURL(file);
    setPreviewImageURL(url);
    const formData = new FormData();
    formData.append("file", file);
    try {
      setLoadingOcr(true);
      const response = await fetch(
        `${OCR_API_URL}medicine_prescription/process`,
        {
          method: "POST",
          headers: {
            "X-API-Key": OCR_API_KEY,
          },
          body: formData,
        },
      );
      const data = await response.json();
      if (data?.detail) {
        toast.error(data.detail);
        setLoadingOcr(false);
        return;
      }
      // Helper function to fetch composition and drugCode
      const fetchMedicineDetails = async (drugName) => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_ES_URL}medicine?freeTextSearch=${drugName}&pageNo=1&pageSize=20`,
          );
          const result = await response.json();
          if (Array.isArray(result) && result.length > 0) {
            const match = result[0];
            return {
              composition: match.composition || "",
              drugCode: match.id || "",
              medicineRate: match.medicineRate || "",
              medicineTypeOfSell: match.medicineTypeOfSell || "",
              drugCategory: match.drugCategory || "",
              prescriptionRequired: match.prescriptionRequired,
            };
          }
        } catch (error) {
          console.error(`Error fetching for ${drugName}:`, error);
        }
        return {
          composition: "",
          drugCode: "",
        };
      };
      // Enhance each medicine with composition and drugCode
      const medicineDetailsRaw = data?.medicine_details || [];
      const enrichedMedicines = await Promise.all(
        medicineDetailsRaw.map(async (item) => {
          const {
            composition,
            drugCode,
            medicineRate,
            medicineTypeOfSell,
            drugCategory,
            prescriptionRequired,
          } = await fetchMedicineDetails(item?.name || "");
          return {
            medicineRate: medicineRate,
            medicineTypeOfSell: medicineTypeOfSell,
            drugCategory: drugCategory,
            drugName: item?.name,
            composition: composition,
            drugCode: drugCode,
            prescriptionRequired: prescriptionRequired,
            dosage: item?.dosage,
            instruction: item?.instructions?.toLowerCase().includes("before")
              ? "1"
              : item?.instructions?.toLowerCase().includes("after")
                ? "0"
                : "2",
            duration: item?.duration,
            notes: item?.notes,
            quantity: item?.quantity,
            drugMType: "Medicine",
            afterBeforeFood: "",
            status: 1,
          };
        }),
      );
      // Lab test details (minimal for now)
      const labTestList = await Promise.all(
        (data?.lab_test_details?.tests || []).map((test) =>
          fetchLabTestDetails(test),
        ),
      );
      // Follow up date - calculate from appointment date, not current date
      const getFormattedDate = (daysToAdd) => {
        // Use the appointment date from selectedPatient, fallback to current date if not available
        const appointmentDate = selectedPatient?.whenAppointment
          ? new Date(selectedPatient.whenAppointment)
          : new Date();
        appointmentDate.setDate(appointmentDate.getDate() + daysToAdd);
        return appointmentDate.toISOString().split("T")[0];
      };
      let followUpDate = null;
      if (data?.schedule_followup) {
        if (data.schedule_followup.after_1_week) {
          followUpDate = getFormattedDate(7);
        } else if (data.schedule_followup.after_15_days) {
          followUpDate = getFormattedDate(15);
        } else if (data.schedule_followup.after_1_month) {
          followUpDate = getFormattedDate(30);
        }
      }
      console.log(labTestList, "labTestList");
      setMainData({
        patientDrugPrescriptionList: enrichedMedicines,
        patientLabTestsList: labTestList,
        recommendation: data?.recommendation || "",
        surgeryRecommendation: data?.surgeryRecommendation || "",
        symptoms: data?.symptoms || [],
        followUpVisitDate: followUpDate,
        diagnosis: data?.diagnosis,
      });
      setPreviewModalOpen(true);
    } catch (err) {
      toast.error("Failed to scan prescription.");
    } finally {
      setLoadingOcr(false);
    }
  };

  const fetchLabTestDetails = async (labTestName) => {
    const token = localStorage.getItem("auth_token");

    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_DIAGNOSISURL
        }partner-labs?labCategory=LAB&freeTextSearch=${encodeURIComponent(
          labTestName,
        )}`,

        {},
      );

      const data = await response.json();

      if (data && Array.isArray(data)) {
        const match = data?.find((test) =>
          test?.displayName?.toLowerCase().includes(labTestName.toLowerCase()),
        );
        console.log(match, "match");

        return {
          labTestName: match?.displayName || labTestName,
          labTestId: match?.Curebaytestcode || match?.Curebaytestcode || "",
          status: 1,
          amount: match?.listPrice || match?.listPrice || "",
          labType: match?.labType || "",
        };
      } else if (Array.isArray(data)) {
        // Fallback in case the response is directly an array
        const match = data.find((test) =>
          test?.name?.toLowerCase().includes(labTestName.toLowerCase()),
        );

        return {
          labTestName: match?.displayName || labTestName,
          labTestId: match?.Curebaytestcode || match?.Curebaytestcode || "",
          status: 1,
          amount: match?.listPrice || match?.listPrice || "",
          labType: match?.labType || "",
        };
      }
    } catch (err) {
      console.error(`Error fetching lab test for ${labTestName}:`, err);
    }

    return {
      labTestName: labTestName,
      labTestId: "",
      status: 1,
      amount: "",
      discountedAmount: "",
    };
  };

  const uploadToServer = async () => {
    setUploading(true);
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    try {
      // const selectedAppointment = scheduledPatients.find(
      //   (item) => item.appointmentId === selectedAppointmentId
      // );
      const visitDate =
        selectedPatient?.whenAppointment ||
        new Date().toISOString().split("T")[0];

      // Calculate follow-up date from appointment date
      const getFormattedDate = (daysToAdd) => {
        const appointmentDate = selectedPatient?.whenAppointment
          ? new Date(selectedPatient.whenAppointment)
          : new Date();
        appointmentDate.setDate(appointmentDate.getDate() + daysToAdd);
        return appointmentDate.toISOString().split("T")[0];
      };

      // Calculate follow-up date based on schedule_followup from OCR data
      // We need to get this data from the OCR response or from a stored variable
      let calculatedFollowUpDate = "";

      // If we have schedule_followup data, calculate the date
      // This should come from the OCR response that was processed earlier
      if (abdmData?.prescription?.schedule_followup) {
        const scheduleFollowup = abdmData.prescription.schedule_followup;
        if (scheduleFollowup.after_1_week) {
          calculatedFollowUpDate = getFormattedDate(7);
        } else if (scheduleFollowup.after_15_days) {
          calculatedFollowUpDate = getFormattedDate(15);
        } else if (scheduleFollowup.after_1_month) {
          calculatedFollowUpDate = getFormattedDate(30);
        }
      } else {
        // Fallback to mainData.followUpVisitDate if no schedule_followup data
        // Ensure we only send the date part, not the time
        calculatedFollowUpDate = mainData.followUpVisitDate
          ? new Date(mainData.followUpVisitDate).toISOString().split("T")[0]
          : "";
      }

      // Sanitize medicine data
      const cleanedDrugList = (mainData.patientDrugPrescriptionList || []).map(
        (med) => ({
          duration: isNaN(Number(med.duration)) ? "" : med.duration,
          quantity: isNaN(Number(med.quantity)) ? "" : med.quantity,
          rate: isNaN(Number(med.medicineRate)) ? "" : med.medicineRate,
          drugName: med.drugName,
          composition: med.composition,
          drugCode: med.drugCode,
          dosage: med.dosage,
          instruction: med.instruction,
          notes: med.notes,
          typeOfSell: med.medicineTypeOfSell,
          drugCategory: med.drugCategory,
          drugMType: "Medicine",
          status: 1,
          prescriptionRequired: med.prescriptionRequired,
        }),
      );
      // Construct JSON payload
      const jsonPayload = {
        visitId: "",
        appointmentId: selectedPatient.appointmentId,
        patientName: selectedPatient?.patientName || "",
        patientMobileNo: selectedPatient?.patientMobileNo || "",
        complaints: selectedPatient?.consultationsReason || "",
        consultReason: selectedPatient?.consultationsReason || "",
        consultationType: selectedPatient?.consultationType || "V",
        userId: selectedPatient?.userId || "",
        diagnostic: "",
        documentType: "e-prescription",
        entryType: "V",
        patientDocument: "",
        followUpVisitDate: calculatedFollowUpDate,
        primaryDiagnosis: mainData.diagnosis?.primary || "",
        primarySymptoms: "",
        recommendation: mainData.recommendation || "",
        roleCode: "",
        saveStatus: "Completed",
        secondaryDiagnosis: mainData.diagnosis?.secondary || "",
        secondarySymptoms: "",
        serviceProvided: "",
        status: 1,
        patientId: selectedPatient?.patientId || "",
        symptomsList: mainData.symptoms || [],
        onset: "",
        bodyPartLocation: "",
        characteristics: "",
        aggravatingFactors: "",
        relievingFactors: "",
        treatmentTaken: "",
        adverseEffect: "",
        severity: "",
        frame: "",
        coating: "",
        nvAssessment: "",
        dvAssessment: "",
        treatmentOption: "",
        surgeryRecommendation: mainData.surgeryRecommendation || "",
        visitDate: visitDate,
        visitSummary: "",
        visitType: selectedPatient?.consultationType || "V",
        comments: "",
        linkType: "e-prescription",
        patientDrugPrescriptionList: cleanedDrugList,
        patientLabTestsList: mainData.patientLabTestsList || [],
        eyeReadingMain: {},
        url: "",
        clinicId: selectedPatient?.clinicId || "",
      };
      console.log(jsonPayload, "jsonPayload");
      // Construct form data
      const formData = new FormData();
      formData.append("prescription", JSON.stringify(jsonPayload));
      formData.append("file", uploadedFile);
      const saveResponse = await fetch(`${API_URL}prescriptions/save`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
        body: formData,
      });
      const saveResult = await saveResponse.json();
      if (saveResult.message) {
        toast.success(
          saveResult.message || "Patient prescription saved successfully",
        );

        // ABDM API call - only if abhaNumber exists
        const abhaNumber = abdmData?.abhaNumber;
        console.log("ABDM Debug - selectedPatient:", selectedPatient);
        console.log("ABDM Debug - abhaNumber:", abhaNumber);
        if (abhaNumber) {
          try {
            // Fetch organization details

            const orgResponse = await fetch(`${API_URL}clinicDetails`, {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
                tenantId: tenantId,
              },
            });
            const orgData = await orgResponse.json();

            // Calculate frequency for each prescription
            const abdmPrescriptions = (
              mainData.patientDrugPrescriptionList || []
            ).map((med) => {
              const dosage = med.dosage || "";
              const frequency = (dosage.match(/1/g) || []).length.toString();

              return {
                drugName: med.drugName || "",
                dosage: med.dosage || "",
                frequency: frequency,
                route: med.route || "Oral",
                duration: med.duration || "",
                instructions: med.notes || "",
                prescriptionDate: "",
                method:
                  med.instruction === "1"
                    ? "Before Meal"
                    : med.instruction === "0"
                      ? "After Meal"
                      : "",
              };
            });

            const abdmPayload = {
              organizationDetails: {
                name: orgData.name || "CureBay eClinic BBSR 2",
                address:
                  orgData.address ||
                  "Plot No: 5208/5840, Ground Floor, At - Sachivalaya Marg, Sainik School Rd, near Zaika Palace, Gajapati Nagar",
                mobile: orgData.mobile || "9437045663",
                hipId: "IN2110000775",
              },
              healthcareProfessionalId:
                abdmData?.doctorId || selectedPatient?.userId || "",
              visitDate: visitDate.split("-").reverse().join("-"), // Convert YYYY-MM-DD to DD-MM-YYYY
              abhaNumber: abhaNumber,
              documentType: "Prescription",
              physicianInfo: {
                name: abdmData?.doctorName || "Dr Rakesh Dash",
                prefix: "",
                gender: "",
                qualification: "",
                contact_info: {
                  phone: "",
                },
              },
              prescriptionsDetails: abdmPrescriptions,
              encounterType: "Outpatient Visit",
              encounterCode: "AMB",
              patientId: "",
              abhaAddress: abdmData?.preferredAbhaAddress || "",
            };

            console.log("ABDM Debug - abdmPayload:", abdmPayload);

            const abdmResponse = await fetch(
              `${process.env.REACT_APP_API_URL_V2}abdm-data-share/save-document`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: ` Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJDVVJFQkFZIiwicm9sZSI6IkFETUlOIiwiaWF0IjoxNzU0MzA0NzQyLCJleHAiOjE3NTQzNDc5NDJ9._EySjnDzpg8UT7I4uy3D3DCUZUB5jwuwmc4yGP4qJd-Uu5DPYhY6QtejqFTfSNozEWrHisGXN7DIKr_CuhNR_w`,
                },
                body: JSON.stringify(abdmPayload),
              },
            );

            if (abdmResponse.ok) {
              console.log("ABDM API call successful");
            } else {
              console.error("ABDM API call failed:", await abdmResponse.text());
            }
          } catch (abdmError) {
            console.error("Error calling ABDM API:", abdmError);
          }
        } else {
          console.log(
            "ABDM Debug - ABDM API call skipped because abhaNumber is:",
            abhaNumber,
          );
        }

        // Refresh page and fetch updated patient list after successful completion
        // setTimeout(() => {
        //   window.location.reload();
        // }, 2000);

        const { startDate, endDate } = dateRange[0];
        fetchPatientList(startDate, endDate);
      } else {
        toast.error(saveResult.error || "Patient prescription failed to save");
      }
      setPreviewModalOpen(false);
    } catch (err) {
      toast.error("Failed to upload or save prescription.");
    } finally {
      setUploading(false);
    }
  };
  const handleEditMedicine = (idx) => {
    const med = mainData.patientDrugPrescriptionList[idx];
    setNewMedicine({
      name: med.drugName,
      composition: med.composition,
      medicineTypeOfSell: med.medicineTypeOfSell,
      medicineRate: med?.medicineRate || "",
      drugCategory: med?.drugCategory || "",
      route: med.route || "",
      drugCode: med?.id || "",
    });
    setEditingMedicineIdx(idx);
    setShowAddModal(true);
  };
  const handleDeleteMedicine = (idx) => {
    setMainData((prev) => ({
      ...prev,
      patientDrugPrescriptionList: prev.patientDrugPrescriptionList.filter(
        (_, i) => i !== idx,
      ),
    }));
  };
  const handleItemClick = (item) => {
    console.log(item, "ghujkl");
    setNewMedicine({
      ...newMedicine,
      name: item.medicineName || "",
      composition: item.composition || "",
      medicineTypeOfSell: item.medicineTypeOfSell || "",
      medicineRate: item.medicineRate || "",
      drugCategory: item.drugCategory || "",
      route: item.route || "",
      drugCode: item.id || "",
      prescriptionRequired: item.prescriptionRequired || "",
    });

    // Add to processing medicines for "Already Added" functionality
    setProcessingMedicines((prev) => new Set([...prev, item.id]));

    setSearchResultsdata([]); // Clear suggestion box
    setIsUserTyping(false); // Prevent API call again on set
  };

  const handleItemClick2 = (item) => {
    console.log(item, "ghujkl");
    setNewMedicine2({
      ...newMedicine2,
      name: item.medicineName || "",
      composition: item.composition || "",
      medicineTypeOfSell: item.medicineTypeOfSell || "",
      medicineRate: item.medicineRate || "",
      drugCategory: item.drugCategory || "",
      drugCode: item.id || "",
      prescriptionRequired: item.prescriptionRequired || "",
    });

    // Add to processing medicines for "Already Added" functionality
    setProcessingMedicines((prev) => new Set([...prev, item.id]));

    setSearchResultsdata([]); // Clear suggestion box
    setIsUserTyping(false); // Prevent API call again on set
  };
  const typeOptions = [
    { label: "Rx", value: "Rx" },
    { label: "NRx", value: "NRx" },
    { label: "XRx", value: "XRx" },
  ];
  const dosageOptions = [
    { label: "Select", value: "" },
    { label: "0-0-1", value: "0-0-1" },
    { label: "0-1-1", value: "0-1-1" },
    { label: "0-1-0", value: "0-1-0" },
    { label: "1-1-1", value: "1-1-1" },
    { label: "1-0-0", value: "1-0-0" },
    { label: "1-0-1", value: "1-0-1" },
    { label: "1-1-0", value: "1-1-0" },
    { label: "1-1-1-1", value: "1-1-1-1" },
    { label: "1-0-0-0", value: "1-0-0-0" },
    { label: "1-1-0-0", value: "1-1-0-0" },
    { label: "1-1-1-0", value: "1-1-1-0" },
    { label: "0-0-0-1", value: "0-0-0-1" },
    { label: "0-0-1-1", value: "0-0-1-1" },
    { label: "0-0-1-0", value: "0-0-1-0" },
    { label: "0-1-0-0", value: "0-1-0-0" },
    { label: "0-1-1-1", value: "0-1-1-1" },
    { label: "s.o.s.", value: "s.o.s." },
    { label: "q.wk.", value: "q.wk." },
    { label: "b.i.d.", value: "b.i.d." },
    { label: "t.i.d.", value: "t.i.d." },
    { label: "q.i.d.", value: "q.i.d." },
    { label: "q.h.s.", value: "q.h.s." },
    { label: "5X a day", value: "5X a day" },
    { label: "q.4h", value: "q.4h" },
    { label: "q.6h", value: "q.6h" },
    { label: "q.o.d.", value: "q.o.d." },
    { label: "prn.", value: "prn." },
    { label: "q.d.", value: "q.d." },
    { label: "I.M.", value: "I.M." },
    { label: "Subq.", value: "Subq." },
    { label: "Rectally", value: "Rectally" },
    { label: "I.V.", value: "I.V." },
    { label: "O.D.", value: "O.D." },
    { label: "O.S.", value: "O.S." },
    { label: "O.U.", value: "O.U." },
    { label: "2 ml", value: "2 ml" },
    { label: "2.5 ml", value: "2.5 ml" },
    { label: "5 ml", value: "5 ml" },
    { label: "10 ml", value: "10 ml" },
  ];
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (isUserTyping && newMedicine.name.trim().length >= 3) {
        fetchMedicine();
      } else {
        setSearchResultsdata([]);
      }
    }, 500); // 500ms debounce

    return () => clearTimeout(delayDebounce); // cleanup
  }, [newMedicine.name, isUserTyping]);
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (isUserTyping && newMedicine2.name.trim().length >= 3) {
        fetchMedicine2();
      } else {
        setSearchResultsdata([]);
      }
    }, 500); // 500ms debounce

    return () => clearTimeout(delayDebounce); // cleanup
  }, [newMedicine2.name, isUserTyping]);

  const fetchMedicine2 = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_ES_URL}medicine?freeTextSearch=${newMedicine2.name}&pageNo=1&pageSize=20`,
      );
      const result = await response.json();
      console.log(result, "jhbhjbjhbj");
      setLoading(false);
      if (result && result.length > 0) {
        setSearchResultsdata(result);
        console.log(result, "dfgyhj");
      } else {
        setSearchResultsdata([]);
      }
    } catch (error) {}
  };

  const fetchMedicine = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_ES_URL}medicine?freeTextSearch=${newMedicine.name}&pageNo=1&pageSize=20`,
      );
      const result = await response.json();
      console.log(result, "jhbhjbjhbj");
      setLoading(false);
      if (result && result.length > 0) {
        setSearchResultsdata(result);
      } else {
        setSearchResultsdata([]);
      }
    } catch (error) {}
  };
  const handleSaveLab = () => {
    setMainData((prev) => {
      const labs = [...prev.patientLabTestsList];
      if (editingLabIdx !== null) {
        // update existing
        labs[editingLabIdx] = {
          ...labs[editingLabIdx],
          labTestName: manualLabTest2,
          labTestId: selectedLabDetails.code,
          amount: selectedLabDetails.amount,
        };
      } else {
        // add new
        labs.push({
          labTestName: manualLabTest,
          amount: "", // or a default
          status: 1,
        });
      }
      return { ...prev, patientLabTestsList: labs };
    });

    // reset & close
    setManualLabTest("");
    setEditingLabIdx(null);
    setShowAddLabModal2(false);
  };
  const cartEntryMap = useMemo(() => {
    const map = new Map();
    (medicines || []).forEach((item) => {
      map.set(item.drugId, item.id); // drugCode === drugId
    });
    return map;
  }, [medicines]);
  // where medicineId === drugCode

  const handleRemoveFromCart = async (medicineId) => {
    const medart = cartList.find((c) => c.cartType === "MED");
    setLoadingMedicines((prev) => new Set(prev).add(medicineId));
    setRemoveMedicineLoading(true); // Start page loader
    const cartItemId = cartEntryMap.get(medicineId);
    console.log(cartItemId, "cartItemId");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}medicine/removeMedicine`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cartId: medart.cartId,
            id: cartItemId, // Use the internal cart entry ID
            patientId: patientDetails.curebayPatientId,
          }),
        },
      );

      const result = await response.json();
      if (response.ok) {
        setSelectedMedicines((prev) => prev.filter((id) => id !== medicineId));
        existingmedicineCodes.delete(medicineId);
        // Also remove from processing medicines when removed from cart
        setProcessingMedicines((prev) => {
          const updated = new Set(prev);
          updated.delete(medicineId);
          return updated;
        });
        toast.success("Medicine removed from cart");
        fetchCartList();
        fetchCartData();
      } else {
        toast.error(result.message || "Failed to remove medicine");
      }
    } catch (error) {
      console.error("Remove API Error:", error);
      toast.error("Something went wrong while removing medicine");
    } finally {
      setLoadingMedicines((prev) => {
        const updated = new Set(prev);
        updated.delete(medicineId);
        return updated;
      });
      setRemoveMedicineLoading(false); // Stop page loader
    }
  };

  const handleRemoveFromCart2 = async (medicineId) => {
    const medart = cartList.find((c) => c.cartType === "MED");
    setLoadingMedicines2((prev) => new Set(prev).add(medicineId));
    setRemoveMedicineLoading(true); // Start page loader

    const cartItemId = cartEntryMap.get(medicineId);
    console.log(cartItemId, "cartItemId");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_CARTURL}medicine/removeMedicine`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cartId: medart.cartId,
            id: cartItemId, // Use the internal cart entry ID
            patientId: patientDetails.curebayPatientId,
          }),
        },
      );

      const result = await response.json();
      if (response.ok) {
        setSelectedMedicines((prev) => prev.filter((id) => id !== medicineId));
        existingmedicineCodes.delete(medicineId);
        // Also remove from processing medicines when removed from cart
        setProcessingMedicines((prev) => {
          const updated = new Set(prev);
          updated.delete(medicineId);
          return updated;
        });
        toast.success("Medicine removed from cart");
        fetchCartList();
        fetchCartData();
      } else {
        toast.error(result.message || "Failed to remove medicine");
      }
    } catch (error) {
      console.error("Remove API Error:", error);
      toast.error("Something went wrong while removing medicine");
    } finally {
      setLoadingMedicines2((prev) => {
        const updated = new Set(prev);
        updated.delete(medicineId);
        return updated;
      });
      setRemoveMedicineLoading(false); // Stop page loader
    }
  };
  const handleAutoCompleteChange2 = (e) => {
    setManualLabTest2(e.value); // ✅ Fix: Allow users to type freely
  };

  // First, separate the lab tests by type
  const pathologyTests = labTestsData.filter(
    (item) => item.labType?.toLowerCase() === "pathology",
  );
  const radiologyTests = labTestsData.filter(
    (item) => item.labType?.toLowerCase() === "radiology",
  );
  const mainDataDrugCodes = new Set(mainData2?.map((item) => item.drugCode));

  // ✅ Collect drugCodes from medicines
  const medicinesDrugCodes = new Set(
    medicinesData?.map((item) => item.drugCode),
  );

  // ✅ Merge both sets into one
const excludedDrugCodes = new Set([
  ...mainDataDrugCodes,
  ...medicinesDrugCodes,
]);

  const serviceCardStyle = {
    maxWidth: 898,
    width: "100%",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
  };
  const serviceCardHeaderStyle = { minHeight: 52 };
  const serviceCardBodyEmptyStyle = { minHeight: 84 };

  const getMedicinePrice = (item) =>
    getMedicineDisplayPrice(item) ??
    item?.rate ??
    item?.medicineRate ??
    item?.unitPrice ??
    null;

  const renderMedicineTypeIcon = (typeOfSell = "") => {
    const type = (typeOfSell || "").toLowerCase();
    const isSyrup =
      type.includes("syrup") ||
      type.includes("bottle") ||
      type.includes("ml") ||
      type.includes("suspension") ||
      type.includes("liquid");
    const isTablet =
      type.includes("tablet") ||
      type.includes("pill") ||
      type.includes("caplet");

    if (isSyrup) {
      return (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M9 3h6v2.5l1.5 3V19a3 3 0 01-3 3h-3a3 3 0 01-3-3V8.5L9 5.5V3z"
            stroke="#0D6B6E"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path d="M12 11v4M10.5 13h3" stroke="#0D6B6E" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    }

    if (isTablet) {
      return (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect
            x="4"
            y="9"
            width="16"
            height="6"
            rx="3"
            stroke="#E85D75"
            strokeWidth="1.5"
          />
          <path d="M12 9v6" stroke="#E85D75" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    }

    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="10" cy="12" r="5.5" stroke="#4A90D9" strokeWidth="1.5" />
        <circle cx="14" cy="12" r="5.5" stroke="#E85D75" strokeWidth="1.5" />
      </svg>
    );
  };

  const renderRowCartAction = ({
    already,
    isLoading,
    onToggle,
    disabled,
    rowKey,
  }) => {
    const iconGradientId = rowKey
      ? `${cartAddGradientId}-${String(rowKey).replace(/[^a-zA-Z0-9-_]/g, "")}`
      : cartAddGradientId;
    if (disabled) return null;

    if (isLoading) {
      return (
        <button
          disabled
          className="inline-flex items-center justify-center w-8 h-8 rounded-lg border border-gray-200 bg-gray-50 text-gray-400"
          aria-label="Updating cart"
        >
          <svg
            className="animate-spin h-3.5 w-3.5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8H4z"
            />
          </svg>
        </button>
      );
    }

    if (already) {
      return (
        <div className="inline-flex items-center rounded-lg border border-green-200 overflow-hidden">
          <span
            className="inline-flex items-center gap-1 px-2 py-1 bg-green-50 text-green-700"
            style={{ fontSize: "11px", fontWeight: 600 }}
          >
            <Check className="w-3 h-3 flex-shrink-0" />
            In Cart
          </span>
          <button
            onClick={onToggle}
            className="px-2 py-1 bg-white text-red-500 hover:bg-red-50 hover:text-red-600 border-l border-green-200 transition-colors"
            style={{ fontSize: "11px", fontWeight: 600 }}
            title="Remove from cart"
          >
            Remove
          </button>
        </div>
      );
    }

    return (
      <button
        type="button"
        onClick={onToggle}
        className="inline-flex items-center bg-transparent border-0 p-0 cursor-pointer hover:opacity-85 transition-opacity flex-shrink-0"
        title="Add to cart"
        aria-label="Add to cart"
      >
        <CartAddIcon gradientId={iconGradientId} />
        <span className="inline-flex flex-col items-start min-w-[2rem]">
          <span
            className="font-semibold leading-none bg-gradient-to-r from-[#004172] to-[#3cba84] bg-clip-text text-transparent"
            style={{ fontSize: "14px" }}
          >
            Add
          </span>
          <span
            className="h-[2px] w-full mt-1 rounded-full bg-gradient-to-r from-[#004172] to-[#3cba84]"
            aria-hidden="true"
          />
        </span>
      </button>
    );
  };

  const renderMedicineOrderRow = ({
    rowKey,
    name,
    typeOfSell,
    quantity,
    price,
    drugCode,
    already,
    isLoading,
    onToggle,
  }) => {
    const numericPrice =
      price != null && price !== "" && !isNaN(Number(price))
        ? Number(price)
        : null;

    return (
      <div
        key={rowKey}
        className="flex items-center justify-between gap-4 px-5 py-2.5 border-b border-gray-100 last:border-b-0"
      >
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div
            className="w-10 h-10 rounded-[10px] flex items-center justify-center flex-shrink-0"
            style={{ background: "#F1F5F9" }}
          >
            {renderMedicineTypeIcon(typeOfSell)}
          </div>
          <div className="min-w-0">
            <p
              className="font-semibold text-[#0D6B6E] mb-0 truncate"
              style={{ fontSize: "14px", lineHeight: 1.3 }}
            >
              {name}
            </p>
            {typeOfSell && (
              <p
                className="text-gray-400 mb-0 truncate"
                style={{ fontSize: "12px", lineHeight: 1.4 }}
              >
                {typeOfSell}
              </p>
            )}
            <p
              className="text-gray-400 mb-0"
              style={{ fontSize: "12px", lineHeight: 1.4 }}
            >
              Qty: {quantity || 1}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3 flex-shrink-0">
          {numericPrice != null && (
            <span
              className="font-bold text-[#003A71] whitespace-nowrap"
              style={{ fontSize: "15px" }}
            >
              ₹{numericPrice}
            </span>
          )}
          {renderRowCartAction({
            already,
            isLoading,
            onToggle,
            disabled: !drugCode,
            rowKey,
          })}
        </div>
      </div>
    );
  };

  const getLabPrice = (item) => {
    const raw = item?.listPrice ?? item?.amount ?? item?.price ?? null;
    if (raw == null || raw === "") return null;
    const num = Number(String(raw).replace(/[₹,]/g, ""));
    return !isNaN(num) ? num : null;
  };

  const renderLabTypeIcon = (labType = "") => {
    const type = (labType || "").toLowerCase();
    const isRadiology = type.includes("radiology") || type.includes("radio");

    if (isRadiology) {
      return (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="7" stroke="#4A90D9" strokeWidth="1.5" />
          <circle cx="12" cy="12" r="3" stroke="#4A90D9" strokeWidth="1.5" />
          <path d="M12 5V3M12 21v-2M5 12H3M21 12h-2" stroke="#4A90D9" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    }

    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M9 3h6l1 4v11a2 2 0 01-2 2h-4a2 2 0 01-2-2V7l1-4z"
          stroke="#E85D75"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path d="M9 7h6" stroke="#E85D75" strokeWidth="1.5" strokeLinecap="round" />
        <rect x="10" y="11" width="4" height="5" rx="1" fill="#FCE7F3" stroke="#E85D75" strokeWidth="1" />
      </svg>
    );
  };

  const renderLabSectionLabel = (label) => (
    <p
      className="px-5 py-2 mb-0 font-semibold text-gray-400 uppercase tracking-wide border-b border-gray-100"
      style={{ fontSize: "11px", background: "#FAFBFC" }}
    >
      {label}
    </p>
  );

  const renderLabSubSectionLabel = (label) => (
    <p
      className="px-5 py-1.5 mb-0 font-medium text-gray-500 border-b border-gray-50"
      style={{ fontSize: "12px", background: "#FCFDFD" }}
    >
      {label}
    </p>
  );

  const normalizeLabCartDetail = (item) => ({
    ...item,
    partnerTestCode:
      item.partnerTestCode || item.labTestId || item.labTestCode || "",
    partnerTestName:
      item.partnerTestName || item.labTestName || item.name || "",
    listPrice: item.listPrice ?? item.amount ?? null,
    diagnosticsCode:
      item.diagnosticsCode || item.hospitalId || item.labId || "",
    locationCode: item.locationCode || item.locationId || "",
    labType: item.labType || item.labTestType || "Pathology",
  });

  const renderLabRowWithCart = (item, rowKey, { useCartRemove = false } = {}) => {
    const detail = normalizeLabCartDetail(item);
    const code = detail.partnerTestCode;
    const already = code ? existingLabTestCodes.has(code) : false;
    const isLoading = code ? loadingLabIds[code] : false;

    return renderLabOrderRow({
      rowKey,
      name: detail.partnerTestName,
      subtitle: detail.diagnosticsName || detail.labType,
      labType: detail.labType,
      price: detail.listPrice,
      testCode: code || null,
      already,
      isLoading,
      onToggle: code
        ? () => {
            if (already) {
              useCartRemove ? handleRemoveLab2(item) : handleRemoveLab(detail);
            } else {
              handleAddLabToCart(detail);
            }
          }
        : null,
    });
  };

  const renderLabOrderRow = ({
    rowKey,
    name,
    subtitle,
    labType,
    price,
    testCode,
    already,
    isLoading,
    onToggle,
  }) => {
    const numericPrice = getLabPrice({ listPrice: price, amount: price, price });

    return (
      <div
        key={rowKey}
        className="flex items-center justify-between gap-4 px-5 py-2.5 border-b border-gray-100 last:border-b-0"
      >
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div
            className="w-10 h-10 rounded-[10px] flex items-center justify-center flex-shrink-0"
            style={{ background: "#F1F5F9" }}
          >
            {renderLabTypeIcon(labType)}
          </div>
          <div className="min-w-0">
            <p
              className={`font-semibold mb-0 truncate ${
                already ? "text-green-600" : "text-[#0D6B6E]"
              }`}
              style={{ fontSize: "14px", lineHeight: 1.3 }}
            >
              {name}
            </p>
            {subtitle && (
              <p
                className="text-gray-400 mb-0 truncate"
                style={{ fontSize: "12px", lineHeight: 1.4 }}
              >
                {subtitle}
              </p>
            )}
          </div>
        </div>

        <div className="flex items-center gap-3 flex-shrink-0">
          {numericPrice != null && (
            <span
              className="font-bold text-[#003A71] whitespace-nowrap"
              style={{ fontSize: "15px" }}
            >
              ₹{numericPrice}
            </span>
          )}
          {renderRowCartAction({
            already,
            isLoading,
            onToggle,
            disabled: !testCode || !onToggle,
            rowKey,
          })}
        </div>
      </div>
    );
  };

  return (
    <OurLayouts
      cartCount={cartItemCount}
      onCartClick={handleCartClick}
      patientId={selectedPatient?.patientId}
      selectedPatient={selectedPatient}
      containScroll
    >
      {loadingOcr && <FullScreenLoader message="Uploading Prescription..." />}
      {removeMedicineLoading && (
        <FullScreenLoader message="Removing Medicine..." />
      )}
      {addMedicineLoading && <FullScreenLoader message="Adding Medicine..." />}
      <div
        className="flex flex-col lg:flex-row flex-1 min-h-0 h-full bg-[#f8fafb] font-inter overflow-y-auto lg:overflow-hidden scroll-smooth overscroll-y-contain"
        style={{
          fontFamily: "Inter, sans-serif",
          fontSize: "15.5px",
          fontWeight: 400,
          lineHeight: 1.4,
          letterSpacing: 0,
        }}
      >
        {/* Sidebar */}
        <div className="w-full lg:w-[420px] border-r border-gray-200 bg-white flex-shrink-0 lg:min-h-0 lg:overflow-y-auto lg:overscroll-y-contain lg:scroll-smooth">
          {patientList.length > 0 ? (
            /* ─── PATIENT SEARCHED VIEW ─── */
            <div className="px-5 py-5">
              {/* Back + Heading */}

              <div className="mb-5">
                <h2
                  className="font-bold text-gray-900 mb-0"
                  style={{ fontSize: "18px", lineHeight: 1.3 }}
                >
                  Patient Appointment Details
                </h2>
              </div>

              {/* Search bar */}
              <div className="relative bg-[#F5F7FA] border border-gray-200 rounded-xl flex items-center mb-3">
                <input
                  type="text"
                  placeholder="Search by patient name or mobile number"
                  value={searchInput}
                  onChange={handleChange}
                  className="flex-1 px-4 py-2.5 bg-transparent text-gray-800 placeholder-gray-400 focus:outline-none rounded-xl"
                  style={{ fontSize: "13.5px" }}
                />
                <Search className="w-4 h-4 text-gray-400 mr-4 flex-shrink-0" />
              </div>

              {/* Date range */}
              <div className="relative mb-4">
                <button
                  className="w-full bg-[#F5F7FA] border border-gray-200 rounded-xl py-2.5 px-4 text-left flex items-center justify-between"
                  onClick={() => setShowCalendar(!showCalendar)}
                >
                  <span
                    className="flex items-center gap-2 text-gray-700"
                    style={{ fontSize: "13.5px" }}
                  >
                    <Calendar className="w-3.5 h-3.5 text-gray-500 flex-shrink-0" />
                    <span>
                      {dateRange?.[0]?.startDate &&
                        format(
                          new Date(dateRange[0].startDate),
                          "dd MMM yyyy",
                        )}{" "}
                      –{" "}
                      {dateRange?.[0]?.endDate &&
                        format(new Date(dateRange[0].endDate), "dd MMM yyyy")}
                    </span>
                  </span>
                </button>
                {showCalendar && (
                  <div
                    ref={calendarRef}
                    className="absolute z-50 mt-2 bg-white border rounded-xl shadow-xl left-0 right-0"
                  >
                    <DateRange
                      locale={enIN}
                      editableDateInputs={true}
                      moveRangeOnFirstSelection={false}
                      ranges={dateRange}
                      onChange={(item) => {
                        setDateRange([item.selection]);
                        const start = item.selection.startDate;
                        const end = item.selection.endDate;
                        if (start && end && start !== end) {
                          setShowCalendar(false);
                          if (selectpatient) {
                            fetchPatientList2(start, end);
                          } else {
                            fetchPatientList(start, end);
                          }
                        }
                      }}
                    />
                  </div>
                )}
              </div>

              {/* Selected patient summary card */}

              {/* Appointment cards */}
              <div className="space-y-3 pb-6">
                {patientList.map((p) => {
                  const isSelected =
                    selectedPatient?.appointmentId === p.appointmentId;
                  let statusLabel = "Pending";
                  let statusBg = "#FFF7ED";
                  let statusText = "#F97316";
                  let statusDotColor = "#F97316";
                  if (p.prescriptionStatus === "Y") {
                    statusLabel = "Complete";
                    statusBg = "#ECFDF5";
                    statusText = "#16A34A";
                    statusDotColor = "#16A34A";
                  } else if (
                    p.prescriptionStatus === "N" &&
                    p.appointmentStatus === "COMPLETED"
                  ) {
                    statusLabel = "Not Complete";
                    statusBg = "#FEF2F2";
                    statusText = "#EF4444";
                    statusDotColor = "#EF4444";
                  }
                  return (
                    <div
                      key={p.appointmentId}
                      onClick={() => {
                        setCurrentAppointmentDetails({
                          appointmentId: p.appointmentId,
                          whenAppointment: p.whenAppointment,
                        });
                        fetchPrescription(p.appointmentId, p);
                      }}
                      className="cursor-pointer transition-all"
                      style={{
                        background: isSelected ? "#F0FAF8" : "#FFFFFF",
                        borderRadius: "12px",
                        border: isSelected
                          ? "1px solid #0D6B6E"
                          : "1px solid #E5E7EB",
                        borderLeftWidth: isSelected ? "3px" : "1px",
                        borderLeftColor: isSelected ? "#0D6B6E" : "#E5E7EB",
                        padding: "14px 16px",
                        boxShadow: isSelected
                          ? "0px 2px 8px 0px rgba(13,107,110,0.10)"
                          : "none",
                      }}
                    >
                      <div className="flex items-start justify-between gap-2 mb-1.5">
                        <p
                          className="font-bold text-gray-900 mb-0 truncate"
                          style={{ fontSize: "13.5px" }}
                        >
                          {p.patientName}
                        </p>
                        <span
                          className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full flex-shrink-0 font-medium"
                          style={{
                            fontSize: "11px",
                            background: statusBg,
                            color: statusText,
                          }}
                        >
                          <span
                            className="w-1.5 h-1.5 rounded-full flex-shrink-0"
                            style={{ background: statusDotColor }}
                          />
                          {statusLabel}
                        </span>
                      </div>
                      <p
                        className="text-gray-400 mb-2"
                        style={{ fontSize: "12px" }}
                      >
                        #{p.appointmentId ? `APT-${p.appointmentId}` : ""}
                      </p>
                      <div
                        className="flex items-center gap-1.5 text-gray-500 mb-1.5"
                        style={{ fontSize: "12px" }}
                      >
                        <Clock className="w-3 h-3 flex-shrink-0 text-gray-400" />
                        <span>
                          {format(new Date(p.whenAppointment), "dd MMM yyyy")} |{" "}
                          {p.fromTime} – {p.toTime}
                        </span>
                      </div>
                      {p.doctorName && (
                        <div
                          className="flex items-center gap-1.5 text-gray-500 mb-2"
                          style={{ fontSize: "12px" }}
                        >
                          <User className="w-3 h-3 flex-shrink-0 text-gray-400" />
                          <span> Dr. {p.doctorName}</span>
                        </div>
                      )}
                      {p.tokenNumber && (
                        <span
                          className="inline-block rounded-md px-2.5 py-0.5 font-semibold"
                          style={{
                            fontSize: "12px",
                            background: "#E6F4F4",
                            color: "#0D6B6E",
                          }}
                        >
                          Token: {p.tokenNumber}
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            /* ─── LANDING VIEW ─── */
            <div className="pr-4 pl-2">
              {/* Header */}
              <div className="mb-7">
                <h2
                  className="font-bold text-gray-900 mb-1.5"
                  style={{ fontSize: "22px", lineHeight: 1.25 }}
                >
                  Book a Service
                </h2>
                <p
                  className="text-gray-500 mb-0"
                  style={{ fontSize: "13.5px", lineHeight: 1.5 }}
                >
                  Search and manage patient services seamlessly
                </p>
              </div>

              {/* Search bar */}
              <div className="group relative bg-[#F5F7FA] border border-gray-200 rounded-xl flex items-center mb-3 shadow-sm transition-all duration-300 focus-within:border-[#0D6B6E]/50 focus-within:ring-2 focus-within:ring-[#0D6B6E]/10 focus-within:bg-white">
                <Search className="w-4 h-4 text-gray-400 ml-4 flex-shrink-0 transition-colors duration-300 group-focus-within:text-[#0D6B6E]" />
                <div className="relative flex-1 min-w-0">
                  {!searchInput && !landingSearchFocused && (
                    <div
                      className="absolute inset-0 flex items-center px-3 pointer-events-none"
                      style={{ fontSize: "13.5px" }}
                    >
                      <AnimatedSearchHint active />
                    </div>
                  )}
                  <input
                    type="text"
                    placeholder={
                      landingSearchFocused && !searchInput
                        ? `${SEARCH_HINT_PREFIX}\u00A0patient name or mobile number`
                        : ""
                    }
                    value={searchInput}
                    onChange={handleChange}
                    onFocus={() => setLandingSearchFocused(true)}
                    onBlur={() => setLandingSearchFocused(false)}
                    className="w-full px-3 py-3 bg-transparent text-gray-800 placeholder-gray-400 focus:outline-none rounded-xl"
                    style={{ fontSize: "13.5px" }}
                    aria-label="Search by patient name or mobile number"
                  />
                </div>
              </div>

              {/* Date range */}
              <div className="relative mt-5">
                <button
                  className="w-full bg-[#F5F7FA] border border-gray-200 rounded-xl py-3 px-4 text-left flex items-center justify-between shadow-sm"
                  onClick={() => setShowCalendar(!showCalendar)}
                >
                  <span
                    className="flex items-center gap-2.5 text-gray-700"
                    style={{ fontSize: "13.5px" }}
                  >
                    <Calendar className="w-4 h-4 text-gray-500 flex-shrink-0" />
                    <span>
                      {dateRange?.[0]?.startDate &&
                        format(
                          new Date(dateRange[0].startDate),
                          "dd MMM yyyy",
                        )}{" "}
                      –{" "}
                      {dateRange?.[0]?.endDate &&
                        format(new Date(dateRange[0].endDate), "dd MMM yyyy")}
                    </span>
                  </span>
                  <span
                    className="font-semibold text-[#0D6B6E]"
                    style={{ fontSize: "13.5px" }}
                  >
                    Change
                  </span>
                </button>
                {showCalendar && (
                  <div
                    ref={calendarRef}
                    className="absolute z-50 mt-2 bg-white border rounded-xl shadow-xl left-0 right-0"
                  >
                    <DateRange
                      locale={enIN}
                      editableDateInputs={true}
                      moveRangeOnFirstSelection={false}
                      ranges={dateRange}
                      onChange={(item) => {
                        setDateRange([item.selection]);
                        const start = item.selection.startDate;
                        const end = item.selection.endDate;
                        if (start && end && start !== end) {
                          setShowCalendar(false);
                          if (selectpatient) {
                            fetchPatientList2(start, end);
                          } else {
                            fetchPatientList(start, end);
                          }
                        }
                      }}
                    />
                  </div>
                )}
              </div>

              {/* Booking made simple stepper card */}
              <div className="bg-[#f4f7f9] border border-gray-100 rounded-xl p-5 mb-10 mt-7">
                <h3
                  className="font-semibold text-gray-900 mb-5"
                  style={{ fontSize: "13.5px" }}
                >
                  Booking made simple
                </h3>
                {(() => {
                  const steps = [
                    {
                      id: 1,
                      label: "Search\nPatient",
                      icon: Search,
                      active: !selectedPatient,
                    },
                    {
                      id: 2,
                      label: "Select\nPatient",
                      icon: Users,
                      active:
                        !!selectedPatient &&
                        !currentAppointmentDetails?.appointmentId,
                    },
                    {
                      id: 3,
                      label: "Pick\nAppointment",
                      icon: Calendar,
                      active: false,
                    },
                    {
                      id: 4,
                      label: "Add\nServices",
                      icon: ClipboardList,
                      active: false,
                    },
                    {
                      id: 5,
                      label: "Confirm\nOrder",
                      icon: CheckCircle2,
                      active: false,
                    },
                  ];
                  return (
                    <div className="flex items-start">
                      {steps.map((step, idx) => {
                        const Icon = step.icon;
                        return (
                          <React.Fragment key={step.id}>
                            {/* Step */}
                            <div className="flex flex-col items-center flex-1 min-w-0">
                              <div className="relative mb-2.5">
                                <div
                                  className={`w-11 h-11 rounded-full flex items-center justify-center transition-all ${
                                    step.active
                                      ? "bg-[#0D6B6E] text-white shadow-md"
                                      : "bg-white border border-gray-200 text-gray-400"
                                  }`}
                                >
                                  <Icon
                                    className="w-[18px] h-[18px]"
                                    strokeWidth={2}
                                  />
                                </div>
                                <div
                                  className={`absolute -bottom-1 -right-1 w-4 h-4 rounded-full text-[9px] font-bold flex items-center justify-center ${
                                    step.active
                                      ? "bg-white text-[#0D6B6E] border border-[#0D6B6E]"
                                      : "bg-gray-100 text-gray-500 border border-gray-200"
                                  }`}
                                >
                                  {step.id}
                                </div>
                              </div>
                              <span
                                className={`text-[10px] leading-tight text-center whitespace-pre-line font-medium ${
                                  step.active
                                    ? "text-[#0D6B6E] font-bold"
                                    : "text-gray-400"
                                }`}
                              >
                                {step.label}
                              </span>
                            </div>

                            {/* Dashed connector — shown between steps, not after the last */}
                            {idx < steps.length - 1 && (
                              <div
                                className="flex-shrink-0 self-start mt-[22px]"
                                style={{
                                  width: "28px",
                                  borderTop: "2px dashed #CBD5E1",
                                }}
                              />
                            )}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  );
                })()}
              </div>
            </div>
          )}
        </div>

        {/* Main Content */}
        <div className="flex-1 min-h-0 p-4 lg:overflow-y-auto lg:overscroll-y-contain lg:scroll-smooth">
          {!selectedPatient ? (
            <div className="max-w-3xl mx-auto flex flex-col gap-6 lg:gap-8">
              {/* Doctor Illustration */}
              <div className="flex items-center justify-center">
                <img src={book} alt="Book a service illustration" />
              </div>

              {/* Recent Patients Card */}

              {/* HIPAA banner */}
              <div
                className="rounded-2xl p-5 flex items-center justify-between shadow-sm"
                style={{
                  background: "linear-gradient(to right, #0D6B6E, #0A9E8A)",
                }}
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center flex-shrink-0">
                    <Shield className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <p
                      className="text-white font-semibold mb-0.5"
                      style={{ fontSize: "13.5px", lineHeight: 1 }}
                    >
                      Quick. Secure. Seamless.
                    </p>
                    <p
                      className="text-white/80 mb-0"
                      style={{ fontSize: "13.5px", lineHeight: 1 }}
                    >
                      All patient data is secure and HIPAA compliant.
                    </p>
                  </div>
                </div>
                <Lock className="w-5 h-5 text-white/70 flex-shrink-0" />
              </div>
            </div>
          ) : (
            <div className="w-full max-w-[898px]">
              {/* ── Patient header bar ── */}
              <div
                className="flex flex-wrap items-center justify-between gap-3 mb-3 px-4 py-3 bg-white rounded-xl"
                style={{
                  border: "1px solid #E5E7EB",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                  maxWidth: 898,
                }}
              >
                <div className="flex items-center gap-3">
                  {/* Avatar */}
                  <div
                    className="w-9 h-9 rounded-full flex items-center justify-center font-bold flex-shrink-0 text-white"
                    style={{ background: "#0D6B6E", fontSize: "13px" }}
                  >
                    {(selectedPatient.patientName || patient?.firstName || "")
                      .split(" ")
                      .slice(0, 2)
                      .map((s) => s[0]?.toUpperCase())
                      .join("")}
                  </div>
                  <div>
                    <h2
                      className="font-bold text-gray-900 mb-1.5"
                      style={{ fontSize: "16px", lineHeight: 1.2 }}
                    >
                      {selectedPatient.patientName ||
                        patient?.firstName + " " + patient?.lastName}
                    </h2>
                    <div className="flex flex-wrap items-center gap-2">
                      {selectedPatient.appointmentId && (
                        <span
                          className="inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 font-medium"
                          style={{
                            fontSize: "12px",
                            background: "#ECFDF5",
                            color: "#16A34A",
                          }}
                        >
                          <span className="w-1.5 h-1.5 rounded-full bg-green-500 inline-block flex-shrink-0" />
                          Appt ID: #{selectedPatient.appointmentId}
                        </span>
                      )}
                      {selectedPatient.whenAppointment && (
                        <span
                          className="inline-flex items-center gap-1.5 rounded-md px-2.5 py-1"
                          style={{
                            fontSize: "12px",
                            background: "#F1F5F9",
                            color: "#475569",
                          }}
                        >
                          <Clock className="w-3 h-3 flex-shrink-0" />
                          {format(
                            new Date(selectedPatient.whenAppointment),
                            "dd MMM yyyy",
                          )}
                          {selectedPatient.fromTime
                            ? ` · ${selectedPatient.fromTime}`
                            : ""}
                        </span>
                      )}
                      {selectedPatient.tokenNumber && (
                        <span
                          className="inline-flex items-center gap-1.5 rounded-md px-2.5 py-1"
                          style={{
                            fontSize: "12px",
                            background: "#F1F5F9",
                            color: "#475569",
                          }}
                        >
                          <MapPin className="w-3 h-3 flex-shrink-0" />
                          Token: {selectedPatient.tokenNumber}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <button
                  onClick={handleMedicineClick2}
                  className="flex items-center gap-2 text-white rounded-lg px-4 py-2 font-bold flex-shrink-0"
                  style={{ background: "#0D6B6E", fontSize: "12px" }}
                >
                  <ShoppingCart className="w-4 h-4" />
                  Go to Cart
                  {/* <span
                    className="bg-white text-[#0D6B6E] rounded-full w-5 h-5 flex items-center justify-center font-bold"
                    style={{ fontSize: "11px" }}
                  >
                    {cartItemCount}
                  </span> */}
                </button>
              </div>

              {/* Symptoms */}
              {/* {selectedPatient.symptomsList?.length > 0 && (
                <div className="text-sm text-gray-700 mb-4 p-3 bg-gray-50 rounded-lg">
                  <strong>Symptoms:</strong>{" "}
                  {selectedPatient.symptomsList
                    .map((s) => s.symptomsName)
                    .join(", ")}
                </div>
              )} */}

              {selectedPatient?.prescriptionStatus !== "N" ? (
                <>
                  {/* Medicine Order */}
                  <div className="bg-white mb-3" style={serviceCardStyle}>
                    <div
                      className="px-4 py-2 flex justify-between items-center"
                      style={{
                        background: "linear-gradient(90deg, #D4EDE9 0%, #FFFFFF 100%)",
                        ...serviceCardHeaderStyle,
                      }}
                    >
                      <h3 className="font-bold text-gray-900 flex items-center gap-2 mb-0" style={{ fontSize: "15px" }}>
                        <span className="w-7 h-7 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                          <img src={bookMedicineIcon} className="w-5 h-5 object-contain" alt="" />
                        </span>
                        Medicine Order
                      </h3>
                      <button
                        onClick={() => setShowAddModal3(true)}
                        className="flex items-center gap-1 text-white rounded-md px-4 py-2 font-semibold bg-gradient-to-r from-[#004172] to-[#3cba84]"
                        style={{ fontSize: "12px" }}
                      >
                        + Add Medicine
                      </button>
                    </div>

                    <div>
                      {medicinesData.map((item) => {
                        const already = existingmedicineCodes.has(item.drugCode);
                        const isLoading = loadingMedicines2.has(item.drugCode);
                        return renderMedicineOrderRow({
                          rowKey: item.id,
                          name: item.name,
                          typeOfSell: item.typeOfSell,
                          quantity: item.quantity,
                          price: getMedicinePrice(item),
                          drugCode: item.drugCode,
                          already,
                          isLoading,
                          onToggle: () =>
                            already
                              ? handleRemoveFromCart2(item.drugCode)
                              : handleAddToCart(item.drugCode),
                        });
                      })}

                      {mainData2.map((item, idx) => {
                        const already =
                          existingmedicineCodes.has(item.drugCode) ||
                          selectedMedicines.includes(item.drugCode);
                        const isLoading = loadingMedicines.has(item.drugCode);
                        return renderMedicineOrderRow({
                          rowKey: `main-${idx}-${item.drugCode || item.name}`,
                          name: item.name,
                          typeOfSell: item.typeOfSell,
                          quantity: item.quantity,
                          price: getMedicinePrice(item),
                          drugCode: item.drugCode,
                          already,
                          isLoading,
                          onToggle: () =>
                            already
                              ? handleRemoveFromCart(item.drugCode)
                              : handleAddToCart2(item.drugCode),
                        });
                      })}

                      {medicines
                        .filter((item) => !excludedDrugCodes.has(item.drugId))
                        .map((item) => {
                          const already = existingmedicineCodes.has(item.drugId);
                          const isLoading = loadingMedicines2.has(item.drugId);
                          return renderMedicineOrderRow({
                            rowKey: item.id,
                            name: item.drugName,
                            typeOfSell: item.medicineTypeOfSell,
                            quantity: item.quantity,
                            price: getMedicinePrice(item),
                            drugCode: item.drugId,
                            already,
                            isLoading,
                            onToggle: () =>
                              already
                                ? handleRemoveFromCart2(item.drugId)
                                : handleAddToCart(item.drugId),
                          });
                        })}
                      {medicinesData.length === 0 &&
                        mainData2.length === 0 &&
                        medicines.length === 0 && (
                          <div
                            className="flex items-center gap-2.5 px-4 py-3"
                            style={serviceCardBodyEmptyStyle}
                          >
                            <img src={bookMedicineIcon} className="w-5 h-5 opacity-25 flex-shrink-0" alt="" />
                            <p className="text-gray-400 mb-0" style={{ fontSize: "13px", lineHeight: 1.5 }}>
                              No medicines added yet. Click{" "}
                              <button onClick={() => setShowAddModal3(true)} className="font-semibold text-[#0D6B6E] hover:underline">Add Medicine</button>{" "}
                              to begin.
                            </p>
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Lab Test Orders */}
                  <div className="bg-white mb-3" style={serviceCardStyle}>
                    <div
                      className="px-4 py-2 flex justify-between items-center"
                      style={{
                        background: "linear-gradient(90deg, #D4EDE9 0%, #FFFFFF 100%)",
                        ...serviceCardHeaderStyle,
                      }}
                    >
                      <h3 className="font-bold text-gray-900 flex items-center gap-2 mb-0" style={{ fontSize: "15px" }}>
                        <span className="w-7 h-7 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                          <img src={bookLabIcon} className="w-5 h-5 object-contain" alt="" />
                        </span>
                        Lab Test Orders
                      </h3>
                      <button
                        className="flex items-center gap-1 text-white rounded-md px-4 py-2 font-semibold bg-gradient-to-r from-[#004172] to-[#3cba84]"
                        style={{ fontSize: "12px" }}
                        onClick={() => setShowAddLabModal(true)}
                      >
                        + Add Lab Test
                      </button>
                    </div>

                    <div>
                      {(pathologyTests.length > 0 || radiologyTests.length > 0) && (
                        <>
                          {renderLabSectionLabel("Doctor Prescribed Tests")}
                          {pathologyTests.length > 0 && (
                            <>
                              {renderLabSubSectionLabel("Pathology Tests")}
                              {pathologyTests.map((item, index) =>
                                renderLabRowWithCart(item, `pathology-${index}`),
                              )}
                            </>
                          )}
                          {radiologyTests.length > 0 && (
                            <>
                              {renderLabSubSectionLabel("Radiology Tests")}
                              {radiologyTests.map((item, index) =>
                                renderLabRowWithCart(item, `radiology-${index}`),
                              )}
                            </>
                          )}
                        </>
                      )}

                      {(() => {
                        const extraSelectedLabs = tempSelectedLabs.filter(
                          (lab) =>
                            ![...pathologyTests, ...radiologyTests].some(
                              (p) =>
                                (p.labTestId || p.labTestCode) ===
                                (lab.partnerTestCode || lab.labTestId),
                            ),
                        );
                        const extraCartLabs = (labCartDetails?.labTestItems || []).filter(
                          (cartLab) => {
                            const code = cartLab.labTestCode;
                            const inPrescribed = [...pathologyTests, ...radiologyTests].some(
                              (p) => (p.labTestId || p.labTestCode) === code,
                            );
                            const inSelected = tempSelectedLabs.some(
                              (lab) => (lab.partnerTestCode || lab.labTestId) === code,
                            );
                            return !inPrescribed && !inSelected;
                          },
                        );

                        if (
                          extraSelectedLabs.length === 0 &&
                          extraCartLabs.length === 0
                        ) {
                          return null;
                        }

                        return (
                          <>
                            {renderLabSectionLabel("Selected Lab Tests")}
                            {extraSelectedLabs.map((lab) =>
                              renderLabRowWithCart(
                                lab,
                                lab.id || lab.curebayTestCode || lab.partnerTestCode,
                              ),
                            )}
                            {extraCartLabs.map((lab) =>
                              renderLabRowWithCart(lab, `cart-${lab.id}`, {
                                useCartRemove: true,
                              }),
                            )}
                          </>
                        );
                      })()}

                      {pathologyTests.length === 0 &&
                        radiologyTests.length === 0 &&
                        tempSelectedLabs.length === 0 &&
                        !labCartDetails?.labTestItems?.length && (
                          <div
                            className="flex items-center gap-2.5 px-4 py-3"
                            style={serviceCardBodyEmptyStyle}
                          >
                            <img src={bookLabIcon} className="w-5 h-5 opacity-25 flex-shrink-0" alt="" />
                            <p className="text-gray-400 mb-0" style={{ fontSize: "13px", lineHeight: 1.5 }}>
                              No lab tests added yet. Click{" "}
                              <button onClick={() => setShowAddLabModal(true)} className="font-semibold text-[#0D6B6E] hover:underline">Add Lab Test</button>{" "}
                              to begin.
                            </p>
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Book Surgery */}
                  <div className="bg-white mb-3" style={serviceCardStyle}>
                    <div
                      className="px-4 py-2 flex justify-between items-center"
                      style={{
                        background: "linear-gradient(90deg, #D4EDE9 0%, #FFFFFF 100%)",
                        ...serviceCardHeaderStyle,
                      }}
                    >
                      <h3 className="font-bold text-gray-900 flex items-center gap-2 mb-0" style={{ fontSize: "15px" }}>
                        <span className="w-7 h-7 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                          <img src={surgeryIcon} className="w-5 h-5 object-contain" alt="" />
                        </span>
                        Book Surgery
                      </h3>
                      <button
                        className="flex items-center gap-1 rounded-md px-3 py-1.5 font-semibold bg-white hover:bg-teal-50 transition-colors"
                        style={{ fontSize: "13px", border: "1px solid #0D6B6E", color: "#0D6B6E" }}
                        onClick={() => setSurgeryModal(true)}
                      >
                        <Globe className="w-3 h-3" />
                        Enquiry
                      </button>
                    </div>
                    <div>
                      {abdmData?.prescription?.surgeryRecommendation ? (
                        <div className="px-4 py-3">
                          <p className="text-[#0D6B6E] font-semibold mb-1" style={{ fontSize: "13px" }}>Doctor Prescribed Surgery</p>
                          <p className="text-gray-700 mb-0" style={{ fontSize: "12px" }}>{abdmData?.prescription?.surgeryRecommendation}</p>
                        </div>
                      ) : (
                        <div className="flex items-center gap-2.5 px-4 py-3" style={serviceCardBodyEmptyStyle}>
                          <HelpCircle className="w-5 h-5 text-gray-300 flex-shrink-0" />
                          <p className="text-gray-400 mb-0" style={{ fontSize: "13px", lineHeight: 1.5 }}>
                            Submit an enquiry to book a surgery for this patient.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Book Ambulance */}
                  <div className="bg-white mb-3" style={serviceCardStyle}>
                    <div
                      className="px-4 py-2 flex justify-between items-center"
                      style={{
                        background: "linear-gradient(90deg, #FFE8E4 0%, #FFFFFF 100%)",
                        ...serviceCardHeaderStyle,
                      }}
                    >
                      <h3 className="font-bold text-gray-900 flex items-center gap-2 mb-0" style={{ fontSize: "15px" }}>
                        <span className="w-7 h-7 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                          <AmbulanceIcon className="w-4 h-4 text-red-500" />
                        </span>
                        Book Ambulance
                      </h3>
                      <button
                        className="flex items-center gap-1 text-white rounded-md px-3 py-1.5 font-semibold"
                        style={{ background: "#E06642", fontSize: "13px" }}
                        onClick={() => setAmbulanceModal(true)}
                      >
                        <Phone className="w-3 h-3" />
                        Book Now
                      </button>
                    </div>
                    <div className="flex items-center gap-2.5 px-4 py-3" style={serviceCardBodyEmptyStyle}>
                      <AmbulanceIcon className="w-5 h-5 text-gray-300 flex-shrink-0" />
                      <p className="text-gray-400 mb-0" style={{ fontSize: "13px", lineHeight: 1.5 }}>
                        Available 24/7. Click <span className="font-semibold text-gray-600">Book Now</span> for emergency ambulance dispatch.
                      </p>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex flex-col items-center justify-center mt-[60px] space-y-4 text-center">
                    <p className="">
                      This appointment doesn't have a prescription yet—click
                      "Upload Prescription" to add one.
                    </p>
                    <button
                      className="bg-gradient-to-r from-[#004172] to-[#3cba84]
               text-white px-4 py-2 rounded-md text-base font-semibold
               flex items-center justify-center gap-2"
                      // onClick={() =>
                      //   handleUploadClick(
                      //     selectedPatient.appointmentId,
                      //     selectedPatient,
                      //     selectedPatient.id
                      //   )
                      // }
                      onClick={handleUploadClick}
                    >
                      Upload Prescription
                    </button>
                    <input
                      type="file"
                      accept="image/*,application/pdf"
                      ref={fileInputRef}
                      onChange={handlePrescriptionUpload}
                      className="hidden"
                    />
                    {/* <input
                      type="file"
                      accept="image/*,application/pdf"
                      ref={(el) => {
                        if (!hiddenFileInput.current)
                          hiddenFileInput.current = [];
                        // hiddenFileInput.current[index] = el;
                      }}
                      onChange={handlePrescriptionUpload}
                      className="hidden"
                    /> */}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>

      <AddLabTestModal
        isOpen={showAddLabModal}
        onClose={() => setShowAddLabModal(false)}
        patientName={
          selectedPatient?.patientName ||
          selectedPatient?.name ||
          patientNameFromNav ||
          ""
        }
        appointmentId={
          selectedPatient?.appointmentId ||
          selectedAppointmentId ||
          currentAppointmentDetails?.appointmentId ||
          ""
        }
        existingCartLabCodes={existingLabTestCodes}
        existingOrderLabKeys={existingOrderLabKeys}
        onAddToOrder={handleAddLabTestsFromModal}
      />

      {searchResults.length > 0 && isSearchModalOpen && (
        <div
          className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-2 sm:p-0"
          onClick={() => setIsSearchModalOpen(false)}
        >
          <div
            className="bg-white rounded-lg shadow-xl w-full max-w-lg sm:max-w-3xl max-h-[80vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex justify-between items-center px-6 py-4 border-b">
              <h3 className="text-xl font-semibold text-[#003A71]">
                Search Results
              </h3>
              <button
                onClick={() => setIsSearchModalOpen(false)}
                className="text-gray-500 hover:text-gray-800 text-2xl leading-none"
              >
                &times;
              </button>
            </div>

            {/* Scrollable Table */}
            <div className="overflow-y-auto max-h-[calc(80vh-64px)] px-6 pb-6">
              <table className="min-w-full text-sm">
                <thead className="bg-gray-100 text-gray-700 font-semibold sticky top-0">
                  <tr>
                    <th className="p-2 text-left">Name</th>
                    <th className="p-2 text-left">Phone Number</th>
                    <th className="p-2 text-left">Age</th>
                    <th className="p-2 text-left">Gender</th>
                    <th className="p-2 text-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {searchResults.map((user, idx) => (
                    <tr key={idx} className="border-t hover:bg-gray-50">
                      <td className="p-2 capitalize">
                        {user.firstName} {user.lastName}
                      </td>
                      <td className="p-2">{user.mobileNumber}</td>
                      <td className="p-2">{user.age}</td>
                      <td className="p-2">{user.gender}</td>
                      <td className="p-2">
                        <button
                          className="bg-[#004276] text-white rounded-md px-4 py-2 hover:bg-[#00345e] transition"
                          // onClick={() =>
                          //   navigate("/PatientDetails", {
                          //     state: { patientCode: user.patientCode },
                          //   })
                          // }
                          onClick={() => {
                            Setselectpatient(user.patientCode);
                            setIsSearchModalOpen(false);
                            setSelectedPatient({
                              patientId: user.patientCode,
                              patientName: `${user.firstName} ${user.lastName}`,
                              prescriptionStatus: "Y", // Assume prescription is complete for search results
                              appointmentId: null,
                              whenAppointment: new Date()
                                .toISOString()
                                .split("T")[0],
                            });
                            fetchPatientdetails(user.patientCode);
                          }}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {previewModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 bg-black bg-opacity-40 overflow-y-auto">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[98vw] sm:max-w-[80rem] p-2 sm:p-8">
            <h3 className="text-2xl font-bold text-[#003A71] mb-6">
              Prescription Preview & OCR Results
            </h3>
            <div className="grid gap-8 grid-cols-1 xl:grid-cols-[28rem_1fr]">
              {/* LEFT: Preview */}
              <div className="border border-gray-200 rounded-lg overflow-hidden">
                {uploadedFile?.type === "application/pdf" ? (
                  <embed
                    src={previewImageURL}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                    className="h-[60vh] w-full"
                  />
                ) : (
                  <img
                    src={previewImageURL}
                    alt="Preview"
                    className="object-contain h-[60vh] w-full"
                  />
                )}
              </div>
              {/* RIGHT: OCR Results */}
              <div className="max-h-[60vh] overflow-y-auto pr-2">
                {/* Medicine Details */}
                <h4 className="text-lg font-semibold text-[#003A71] mb-2">
                  Medicine Details
                </h4>
                <button
                  onClick={() => {
                    setEditingMedicineIdx(null);
                    setShowAddModal(true);
                  }}
                  className="text-sm bg-green-100 text-green-800 px-2 py-1 rounded mb-4"
                >
                  + Add Medicine
                </button>
                <table className="w-full text-sm border-collapse mb-6">
                  <thead className="bg-[#F0FCFA] sticky top-0">
                    <tr>
                      {[
                        "Name",
                        "Dosage",
                        "Instructions",
                        "Duration",
                        "Qty",
                        "Amount",
                        "Type",
                        "Route",
                        "Edit",
                        "Delete",
                      ].map((h) => (
                        <th
                          key={h}
                          className="px-3 py-2 text-left text-[#003A71] font-medium"
                        >
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {mainData.patientDrugPrescriptionList.map((med, i) => (
                      <tr key={i}>
                        <td className="px-3 py-2">{med.drugName}</td>
                        <td className="px-3 py-2">{med.dosage || "—"}</td>
                        <td className="px-3 py-2">
                          {med.instruction === "0"
                            ? "After Meal"
                            : med.instruction === "1"
                              ? "Before Meal"
                              : ""}
                        </td>
                        <td className="px-3 py-2">{med.duration || "—"}</td>
                        <td className="px-3 py-2">{med.quantity || "—"}</td>
                        <td className="px-3 py-2">{med.medicineRate || "—"}</td>
                        <td className="px-3 py-2">
                          {med.medicineTypeOfSell || "—"}
                        </td>
                        <td className="px-3 py-2">{med.route || "—"}</td>
                        <td className="px-3 py-2">
                          <button onClick={() => handleEditMedicine(i)}>
                            <Edit2 className="w-5 h-5 text-[#004276] hover:opacity-75" />
                          </button>
                        </td>
                        <td className="px-3 py-2">
                          <button onClick={() => handleDeleteMedicine(i)}>
                            <Trash2 className="w-5 h-5 text-red-500 hover:opacity-75" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* Lab-Test Details */}
                {mainData.patientLabTestsList.length > 0 && (
                  <>
                    <h4 className="text-lg font-semibold text-[#003A71] mb-2">
                      Lab Test Details
                    </h4>
                    <button
                      onClick={() => {
                        setEditingLabIdx(null);
                        setShowAddLabModal2(true);
                      }}
                      className="text-sm bg-green-100 text-green-800 px-2 py-1 rounded mb-4"
                    >
                      + Add Lab Test
                    </button>
                    <table className="w-full text-sm border-collapse">
                      <thead className="bg-[#F0FCFA] sticky top-0">
                        <tr>
                          {["Test Name", "Amount", "Edit", "Delete"].map(
                            (h) => (
                              <th
                                key={h}
                                className="px-3 py-2 text-left text-[#003A71] font-medium"
                              >
                                {h}
                              </th>
                            ),
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {mainData.patientLabTestsList.map((test, i) => (
                          <tr key={i}>
                            <td className="px-3 py-2">{test.labTestName}</td>
                            <td className="px-3 py-2">{test.amount || "—"}</td>
                            <td className="px-3 py-2">
                              <button onClick={() => handleEditLab(i)}>
                                <Edit2 className="w-5 h-5 text-[#004276]" />
                              </button>
                            </td>
                            <td className="px-3 py-2">
                              <button onClick={() => handleDeleteLab(i)}>
                                <Trash2 className="w-5 h-5 text-red-500" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )}

                {/* Recommendation and Follow-up Date Section */}
                <div className="mt-6 space-y-4">
                  <h4 className="text-lg font-semibold text-[#003A71] mb-2">
                    Additional Details
                  </h4>

                  {/* Recommendation */}
                  <div>
                    <label className="block text-sm font-medium text-[#003A71] mb-2">
                      Recommendation
                    </label>
                    <textarea
                      value={mainData.recommendation || ""}
                      onChange={(e) =>
                        setMainData({
                          ...mainData,
                          recommendation: e.target.value,
                        })
                      }
                      placeholder="Enter recommendation..."
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#004276] focus:border-transparent resize-none"
                      rows="3"
                    />
                  </div>

                  {/* Surgery Recommendation */}
                  <div>
                    <label className="block text-sm font-medium text-[#003A71] mb-2">
                      Surgery Recommendation
                    </label>
                    <textarea
                      value={mainData.surgeryRecommendation || ""}
                      onChange={(e) =>
                        setMainData({
                          ...mainData,
                          surgeryRecommendation: e.target.value,
                        })
                      }
                      placeholder="Enter surgery recommendation..."
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#004276] focus:border-transparent resize-none"
                      rows="3"
                    />
                  </div>

                  {/* Follow-up Date */}
                  <div>
                    <label className="block text-sm font-medium text-[#003A71] mb-2">
                      Follow-up Date
                    </label>
                    {mainData.followUpVisitDate ? (
                      <input
                        type="date"
                        value={
                          mainData.followUpVisitDate
                            ? new Date(mainData.followUpVisitDate)
                                .toISOString()
                                .split("T")[0]
                            : ""
                        }
                        onChange={(e) => {
                          const selectedDate = new Date(e.target.value);
                          const today = new Date();
                          today.setHours(0, 0, 0, 0); // Reset time to start of day

                          // Only allow future dates or today
                          if (selectedDate >= today) {
                            setMainData({
                              ...mainData,
                              followUpVisitDate: e.target.value,
                            });
                          } else {
                            // If past date is selected, don't update the state
                            console.log(
                              "Past date selected, ignoring selection",
                            );
                          }
                        }}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#004276] focus:border-transparent"
                        min={new Date().toISOString().split("T")[0]} // Prevent selecting past dates
                      />
                    ) : (
                      <div className="w-full p-3 border border-gray-300 rounded-lg bg-gray-50 text-gray-500">
                        No follow-up date scheduled
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Actions */}
            <div className="mt-8 flex justify-end gap-4">
              <button
                onClick={() => window.location.reload()}
                className="py-2 px-6 rounded-lg border border-[#004276] text-[#004276] hover:bg-[#E7F1FF]"
              >
                Cancel
              </button>
              <button
                onClick={uploadToServer}
                className="py-2 px-6 rounded-lg bg-[#004276] text-white hover:bg-[#00305C]"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
      {showAddModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-2 sm:p-0">
          <div className="bg-white p-4 sm:p-6 rounded-lg w-full max-w-lg sm:max-w-6xl shadow-xl overflow-y-auto max-h-[95vh]">
            {/* Header */}
            <div className="flex justify-between items-start mb-4">
              <h2 className="text-xl font-semibold">
                {editingMedicineIdx !== null ? "Edit Medicine" : "Add Medicine"}
              </h2>
              <button
                onClick={() => {
                  setShowAddModal(false);
                  setEditingMedicineIdx(null);
                }}
                className="text-2xl leading-none"
              >
                ×
              </button>
            </div>

            {/* Form Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 items-start">
              {/* Medicine Name */}
              <div className="col-span-1">
                <label className="text-sm font-semibold">Medicine Name</label>
                <input
                  type="text"
                  placeholder="Search/Add Medicine"
                  className="border p-2 rounded w-full"
                  value={newMedicine.name}
                  onChange={(e) => {
                    setIsUserTyping(true);
                    const newValue = e.target.value;
                    setNewMedicine({ ...newMedicine, name: newValue });

                    // If the field is cleared, remove the medicine from processingMedicines and clear drugCode
                    if (!newValue.trim()) {
                      setProcessingMedicines((prev) => {
                        const newSet = new Set(prev);
                        // Remove all medicines that were added through this field
                        // We need to check if this medicine is currently in the field
                        if (newMedicine.drugCode) {
                          newSet.delete(newMedicine.drugCode);
                        }
                        return newSet;
                      });
                      // Clear the drugCode when field is cleared
                      setNewMedicine((prev) => ({
                        ...prev,
                        drugCode: "",
                        composition: "",
                        medicineTypeOfSell: "",
                        medicineRate: "",
                        drugCategory: "",
                        prescriptionRequired: "",
                      }));
                    }
                  }}
                />

                {loading ? (
                  <p>Loading...</p>
                ) : searchResultsdata.length > 0 ? (
                  <div
                    style={{
                      padding: "9px 0px 0px 12px",
                      position: "absolute",
                      backgroundColor: "white",
                      width: "37%",
                      border: "1px solid #ccc",
                      maxHeight: "300px",
                      overflowY: "auto",
                      zIndex: 50,
                    }}
                  >
                    <ul>
                      {searchResultsdata.map((item) => {
                        const isAlreadySelected =
                          existingmedicineCodes.has(item.id) ||
                          processingMedicines.has(item.id);
                        const isAlreadyInPrescription = medicinesData.some(
                          (med) =>
                            med.name?.toLowerCase() ===
                              item.medicineName?.toLowerCase() ||
                            med.drugName?.toLowerCase() ===
                              item.medicineName?.toLowerCase(),
                        );
                        const isDisabled =
                          isAlreadySelected || isAlreadyInPrescription;

                        return (
                          <li key={item.id}>
                            <button
                              onClick={() => handleItemClick(item)}
                              disabled={isDisabled}
                              className={`w-full text-left px-2 py-1 ${
                                isDisabled
                                  ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                                  : "hover:bg-gray-100"
                              }`}
                            >
                              <div className={`font-medium `}>
                                {item.medicineName}
                                {isAlreadySelected && (
                                  <span className="ml-2 text-xs bg-red-100 text-red-600 px-2 py-1 rounded">
                                    Already Added
                                  </span>
                                )}
                                {isAlreadyInPrescription &&
                                  !isAlreadySelected && (
                                    <span className="ml-2 text-xs bg-orange-100 text-orange-600 px-2 py-1 rounded">
                                      Already in Prescription
                                    </span>
                                  )}
                              </div>
                            </button>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : null}
              </div>

              {/* Composition */}
              <div className="col-span-1">
                <label className="text-sm font-semibold">Composition</label>
                <input
                  type="text"
                  placeholder="Composition"
                  className="border p-2 rounded w-full text-gray-400"
                  value={newMedicine.composition}
                  readOnly
                />
              </div>
              <div className="col-span-1">
                <label className="text-sm font-semibold">Drug Category</label>
                <input
                  type="text"
                  placeholder="Drug Category"
                  className="border p-2 rounded w-full text-gray-400"
                  value={newMedicine.drugCategory}
                  readOnly
                />
              </div>
              <div className="col-span-1">
                <label className="text-sm font-semibold">Type of Sell</label>
                <input
                  type="text"
                  placeholder="Type of Sell"
                  className="border p-2 rounded w-full text-gray-400"
                  value={newMedicine.medicineTypeOfSell}
                  readOnly
                />
              </div>
              <div className="col-span-1">
                <label className="text-sm font-semibold">Rate</label>
                <input
                  type="text"
                  placeholder="Rate"
                  className="border p-2 rounded w-full text-gray-400"
                  value={newMedicine.medicineRate}
                  readOnly
                />
              </div>

              {/* Quantity */}
              <div className="col-span-1">
                <label className="text-sm font-semibold">Quantity</label>
                <input
                  type="number"
                  min={1}
                  className="border p-2 rounded w-full"
                  value={newMedicine.quantity}
                  onChange={(e) =>
                    setNewMedicine({
                      ...newMedicine,
                      quantity: Number(e.target.value),
                    })
                  }
                />
              </div>

              {/* Dosage */}
              <div className="col-span-1">
                <label className="text-sm font-semibold">Dosage</label>
                <select
                  className="border p-2 rounded w-full"
                  value={newMedicine.dosage}
                  onChange={(e) =>
                    setNewMedicine({ ...newMedicine, dosage: e.target.value })
                  }
                >
                  {dosageOptions.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Instructions */}
              <div className="col-span-1">
                <label className="text-sm font-semibold">Instructions</label>
                <select
                  className="border p-2 rounded w-full"
                  value={newMedicine.instructions}
                  onChange={(e) =>
                    setNewMedicine({
                      ...newMedicine,
                      instructions: e.target.value,
                    })
                  }
                >
                  <option value="None">None</option>
                  <option value="After Meal">After Meal</option>
                  <option value="Before Meal">Before Meal</option>
                </select>
              </div>

              {/* Duration */}
              <div className="col-span-1">
                <label className="text-sm font-semibold">Duration</label>
                <select
                  className="border p-2 rounded w-full"
                  value={newMedicine.duration}
                  onChange={(e) =>
                    setNewMedicine({ ...newMedicine, duration: e.target.value })
                  }
                >
                  <option value="">Select Duration</option>
                  {[...Array(30)].map((_, i) => (
                    <option key={i} value={`${i + 1}`}>
                      {i + 1}
                    </option>
                  ))}
                </select>
              </div>

              {/* Route */}
              <div className="col-span-1">
                <label className="text-sm font-semibold">Route</label>
                <select
                  className="border p-2 rounded w-full"
                  value={newMedicine.route}
                  onChange={(e) =>
                    setNewMedicine({
                      ...newMedicine,
                      route: e.target.value,
                    })
                  }
                >
                  <option value="">Select Route</option>
                  <option value="Oral">Oral</option>
                  <option value="Topical">Topical</option>
                  <option value="Intravenous">Intravenous (IV)</option>
                  <option value="Intramuscular">Intramuscular (IM)</option>
                  <option value="Subcutaneous">Subcutaneous</option>
                  <option value="Nasal">Nasal</option>
                  <option value="Inhalation">Inhalation</option>
                </select>
              </div>

              {/* Type */}
              {/* <div className="col-span-1">
                      <label className="text-sm font-semibold">Type</label>
                      <select
                        className="border p-2 rounded w-full"
                        value={newMedicine.medicineTypeOfSell}
                        onChange={(e) =>
                          setNewMedicine({ ...newMedicine, medicineTypeOfSell: e.target.value })
                        }
                      >
                        {typeOptions.map((option, index) => (
                          <option key={index} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div> */}
            </div>

            {/* Actions */}
            <div className="mt-6 flex justify-end gap-4">
              <button
                onClick={() => {
                  setShowAddModal(false);
                  setEditingMedicineIdx(null);
                }}
                className="text-gray-600 hover:text-gray-900"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveMedicine}
                className="bg-[#004276] text-white px-6 py-2 rounded"
              >
                {editingMedicineIdx !== null ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showAddLabModal2 && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-2 sm:p-0">
          <div className="bg-white rounded-xl w-full max-w-md p-4 sm:p-6 shadow-xl overflow-y-auto max-h-[95vh]">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-semibold text-gray-800">
                {editingLabIdx !== null ? "Edit Lab Test" : "Add Lab Test"}
              </h2>
              <button
                onClick={() => {
                  setShowAddLabModal2(false);
                  setEditingLabIdx(null);
                }}
                className="text-gray-400 hover:text-gray-600 text-lg"
              >
                ×
              </button>
            </div>

            {/* Test Name */}
            <label className="block text-sm text-gray-600 font-medium mb-1">
              Test Name
            </label>
            {loading ? (
              <div className="flex justify-center">
                <ProgressSpinner style={{ width: "40px", height: "40px" }} />
              </div>
            ) : (
              <AutoComplete
                id="test-autocomplete"
                value={manualLabTest2}
                suggestions={[]}
                completeMethod={searchTests2}
                field="label"
                dropdown
                placeholder="Search a test"
                onChange={handleAutoCompleteChange2}
                style={{
                  width: "100%",
                  border: "1px solid gray",
                  padding: "5px",
                  borderRadius: "5px",
                }}
                className="w-full"
              />
            )}

            {/* Show suggestions */}
            {filteredOptions.length > 0 && (
              <div className="border border-gray-200 rounded mt-2 max-h-64 overflow-y-auto shadow-sm">
                <ul className="text-sm text-gray-700">
                  {filteredOptions.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        console.log(item, "fgyhjkl");
                        setManualLabTest2(item.label);
                        setSelectedLabDetails({
                          amount: item.amount || "",
                          code: item.code || "",
                        });
                        setFilteredOptions([]);
                      }}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    >
                      {item.label}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Selected Test Info */}
            {/* {manualLabTest2 && (
              <div className="mt-4 text-sm text-gray-600 space-y-2">
                <div>
                  <span className="font-medium">Test Code:</span>{" "}
                  {selectedLabDetails.code || "N/A"}
                </div>
                <div>
                  <span className="font-medium">Amount:</span> ₹
                  {selectedLabDetails.amount || "N/A"}
                </div>
              </div>
            )} */}

            {/* Actions */}
            <div className="flex justify-end gap-4 mt-6">
              <button
                onClick={() => {
                  setShowAddLabModal2(false);
                  setEditingLabIdx(null);
                }}
                className="text-gray-600 hover:text-gray-900"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveLab}
                className="bg-gradient-to-r from-[#004172] to-[#3cba84] text-white px-6 py-2 rounded-full text-sm font-medium"
              >
                {editingLabIdx !== null ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}

      <AddMedicineModal
        isOpen={showAddModal3}
        onClose={() => setShowAddModal3(false)}
        patientName={
          selectedPatient?.patientName ||
          selectedPatient?.name ||
          patientNameFromNav ||
          ""
        }
        appointmentId={
          selectedPatient?.appointmentId ||
          selectedAppointmentId ||
          currentAppointmentDetails?.appointmentId ||
          ""
        }
        existingCartDrugIds={existingmedicineCodes}
        existingOrderDrugIds={existingOrderDrugIds}
        prescriptionDrugNames={prescriptionDrugNames}
        onAddToOrder={handleAddMedicinesFromModal}
      />
      <PaymentModeModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onPay={handlePay}
        setPaymentMode={setPaymentMode}
        isLoggingIn={isLoggingIn}
        paymentMode={paymentMode}
        paymentItem={orderid}
        paymenttype="Order"
      />
      {CartOpen && (
        <CartDropdown
          patientId={selectedPatient?.patientId}
          selectedPatient={selectedPatient}
          onClose={() => setCartOpen(false)}
          abdmData={abdmData}
        />
      )}

      {/* surgery */}
      {surgerymodal && (
        <Surgery
          isOpen={surgerymodal}
          onClose={() => setSurgeryModal(false)}
          patientId={selectedPatient?.patientId}
          appointmentId={selectedPatient?.appointmentId}
          doctorName={
            selectedPatient?.doctorName ||
            selectedPatient?.doctor ||
            ""
          }
        />
      )}

      {ambulanceModal && (
        <Ambulance
          isOpen={ambulanceModal}
          onClose={() => setAmbulanceModal(false)}
          patientId={selectedPatient?.patientId}
          appointmentId={selectedPatient?.appointmentId}
          doctorName={
            selectedPatient?.doctorName ||
            selectedPatient?.doctor ||
            ""
          }
        />
      )}
    </OurLayouts>
  );
}

export default App;
